var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenobi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544 544",
    width: 544,
    height: 544,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kenobi(2)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f4e2bb } \n\t\t.s1 { fill: #fbba78 } \n\t\t.s2 { fill: #422013 } \n\t\t.s3 { fill: #6a3711 } \n\t\t.s4 { fill: #985c3f } \n\t\t.s5 { fill: #6b3711 } \n\t\t.s6 { fill: #f4e1bb } \n\t\t.s7 { fill: #6b3611 } \n\t\t.s8 { fill: #ebe2c2 } \n\t\t.s9 { fill: #6b370e } \n\t\t.s10 { fill: #442112 } \n\t\t.s11 { fill: #c6925d } \n\t\t.s12 { fill: #fbf1bc } \n\t\t.s13 { fill: #261e1a } \n\t\t.s14 { fill: #693b18 } \n\t\t.s15 { fill: #c38f5e } \n\t\t.s16 { fill: #4e2a14 } \n\t\t.s17 { fill: #d2ceb5 } \n\t\t.s18 { fill: #4d331a } \n\t\t.s19 { fill: #f6ba7b } \n\t\t.s20 { fill: #441809 } \n\t\t.s21 { fill: #fdf5d0 } \n\t\t.s22 { fill: #ebe8cd } \n\t\t.s23 { fill: #fbf3c2 } \n\t\t.s24 { fill: #eeead1 } \n\t\t.s25 { fill: #e7b586 } \n\t\t.s26 { fill: #ecc08b } \n\t\t.s27 { fill: #61381b } \n\t\t.s28 { fill: #fdfde9 } \n\t\t.s29 { fill: #684427 } \n\t\t.s30 { fill: #f0c393 } \n\t\t.s31 { fill: #f2e2c7 } \n\t\t.s32 { fill: #eac597 } \n\t\t.s33 { fill: #462e1a } \n\t\t.s34 { fill: #fdf9da } \n\t\t.s35 { fill: #bfafa3 } \n\t\t.s36 { fill: #efd3a2 } \n\t\t.s37 { fill: #f6dfa8 } \n\t\t.s38 { fill: #f9f5d5 } \n\t\t.s39 { fill: #f1e7ca } \n\t\t.s40 { fill: #f4eed0 } \n\t\t.s41 { fill: #f2ca9b } \n\t\t.s42 { fill: #f4c88e } \n\t\t.s43 { fill: #6e594c } \n\t\t.s44 { fill: #f1c083 } \n\t\t.s45 { fill: #f1e9cf } \n\t\t.s46 { fill: #fef3bc } \n\t\t.s47 { fill: #452011 } \n\t\t.s48 { fill: #a69482 } \n\t\t.s49 { fill: #3f1405 } \n\t\t.s50 { fill: #f7edb9 } \n\t\t.s51 { fill: #6e4420 } \n\t\t.s52 { fill: #fcca7a } \n\t\t.s53 { fill: #ae7943 } \n\t\t.s54 { fill: #2a0f09 } \n\t\t.s55 { fill: #5d2f12 } \n\t\t.s56 { fill: #eab178 } \n\t\t.s57 { fill: #4d2506 } \n\t\t.s58 { fill: #d0caad } \n\t\t.s59 { fill: #cdbb9d } \n\t\t.s60 { fill: #dec3a9 } \n\t\t.s61 { fill: #713b14 } \n\t\t.s62 { fill: #f9bc79 } \n\t\t.s63 { fill: #6e3c14 } \n\t\t.s64 { fill: #743d13 } \n\t\t.s65 { fill: #f2bb7c } \n\t\t.s66 { fill: #ddd6b7 } \n\t\t.s67 { fill: #261f1d } \n\t\t.s68 { fill: #cba371 } \n\t\t.s69 { fill: #5c595a } \n\t\t.s70 { fill: #f4bf7b } \n\t\t.s71 { fill: #784114 } \n\t\t.s72 { fill: #cdbea1 } \n\t\t.s73 { fill: #6a3e1d } \n\t\t.s74 { fill: #5c5a5b } \n\t\t.s75 { fill: #4e250e } \n\t\t.s76 { fill: #fcedb5 } \n\t\t.s77 { fill: #f8efc8 } \n\t\t.s78 { fill: #54290f } \n\t\t.s79 { fill: #f0c68e } \n\t\t.s80 { fill: #8c5a2d } \n\t\t.s81 { fill: #f7e0ac } \n\t\t.s82 { fill: #454141 } \n\t\t.s83 { fill: #352f32 } \n\t\t.s84 { fill: #cb8545 } \n\t\t.s85 { fill: #fbe6b0 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m342 390.1c-4.2 7-8.5 14-12.5 21-5.6 9.6-10.5 19.6-16.6 28.7-7.2 10.8-16.4 19.7-29.3 23.8 0.7-3 2-5.6 2.8-8.2 4.9-14.9 10-29.7 14.4-44.7 6.4-21.5 12.4-43.1 18.4-64.7 0.5-1.9-0.1-4-0.1-6.3 4.2-1 1.2-3 1.3-4.5 1.3-1.4 2.5-2.6 3.1-4.1 3.3-7.9 6.5-15.8 10.1-23.8 7.1-5 8.6-5.2 11-0.4 2.6 5.3 6.7 6.4 12.1 6.7 4 0.2 8.1 1.4 11.6 3.2 2.8 1.4 4.5 1.4 6.5-0.7 1.4-1.4 2.8-2.9 4.4-4.1 5.3-4 15.6-3 19.8 2.5 0.6 4.3 1.1 8.3 1.7 12.2 2 13.8 4.1 27.5 6 41.5 0 0.7 0.2 1.2 0.4 2.2 0.3 2.1 0.6 3.9 0.6 5.9 0.3 5.4 0.8 10.5 1.3 16 0 1.9 0.1 3.4 0.1 5.3-0.4 5.8-0.7 11.1-1 16.7-0.6 5.5-1.3 10.7-2 15.8-0.4 0.8-0.8 1.5-1.6 2.7-0.8 3.7-1.1 7-1.4 10.3 0 0-0.1-0.1-0.4 0-3.5 0.3-6.6 0.6-9.8 0.9-0.5-0.3-0.9-0.6-1.7-1.4-3.6-0.5-6.8-0.6-10-0.6 0 0-0.2-0.4-0.2-1.1-0.3-3.1-0.6-5.5-0.8-7.9-3.6-4-7.2-3.3-9.2 1.6-0.6 1.5-1.5 2.8-2.9 4.3-1.9-1-3-2-4.1-3.1-0.7-0.9-1.2-1.9-1.9-2.8 0-0.4-0.1-0.9 0.1-1.8-0.3-1.4-0.8-2.2-1.3-3q-1.9 1.5-3.9 2.9c0 0 0 0.5-0.3 0.8-0.4 0.6-0.6 0.9-0.6 1.2 0 0 0-0.1-0.2 0.1-0.5 0.4-0.7 0.6-0.9 0.9 0 0 0-0.1-0.2 0.1-0.4 0.4-0.6 0.6-0.8 0.9 0 0 0 0.5-0.3 0.8-0.5 0.6-0.6 0.9-0.7 1.2 0 0 0 0.5-0.3 0.8-0.4 0.6-0.6 0.9-0.6 1.2 0 0-0.1-0.1-0.4-0.1-1.4-1-2.4-2.3-3.7-3-1.2-0.7-3.6-1.4-4-1-1.1 1.5-1.5 3.6-2.1 5.4 0 0-0.2 0.4-0.6 0.2-1.3-1-2.2-1.8-3.2-2.6-0.4-0.3-0.9-0.6-2-1.2-2.3-0.4-4.1-0.6-5.9-0.8-0.1-0.5-0.1-0.9 0.1-1.8 0.4-0.7 0.6-1 0.7-1.3 0 0 0-0.5 0.4-0.8 0.8-1.9 1.2-3.6 1.6-5.2 2.6-8.8 5.2-17.5 8.3-26.7 2.4-5.8 4.3-10.9 6.2-16.1q-1.2-0.5-2.4-0.9-1.5 3.5-3.1 6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m112 262.8c0 0-0.4 0.2-0.9 0.3-0.7 0.4-0.9 0.7-1.1 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.3 0-1.4 2.6-3 5.2-3.4 7.9-0.2 1.1 1.8 2.6 2.8 3.9 0 0-0.1 0.1-0.1 0.4 0 0.5 0 0.8 0 1.4-0.4 9.1-0.8 17.6-1.4 26.6-0.2 3.4-0.2 6.5-0.4 10 0.2 2.5 0.5 4.6 0.7 7.2 0.4 5.4 1 10.4 1.1 15.4 0.2 10.8-0.1 21.8-5.7 31.5-4.8 8.1-10 16.1-15.7 23.7-5 6.6-10.5 12.9-16.6 18.4-7.3 6.5-13.6 4.9-16.1-4.5-3.1-11.7-4.7-23.9-6.9-36.4 0.7-16.1 1.3-31.9 2-48 1.2-2.7 2.4-5.1 3.4-7.6 4.4-11.4 9.1-22.7 12.9-34.4 1-3-0.8-7-1.2-10.5-0.6-3.7-0.9-7.4-1.7-11-0.3-1.5-1.5-2.8-2.4-5-0.2-4.1-0.6-7.2-5.1-7 0 0 0.1-0.1 0-0.3-0.4-0.4-0.7-0.6-1-0.8 0 0 0.1 0 0-0.2-0.4-0.4-0.7-0.6-1-0.8 0 0 0.1 0 0.1-0.3-1.4-1.8-2.8-3.2-4.1-4.7 0 0 0.1 0 0-0.2-0.2-0.5-0.5-0.7-0.8-0.8 0 0-0.1-0.4-0.1-1 0.7-2.1 1.3-3.5 2.3-4.8 2.4 2.1 4.5 4 6.7 6.2 1.1 0.4 2 0.5 3.4 0.6 1.8 0 3.2 0 4.9 0.3 3.4 0.4 6.7 3.2 9.9-0.2 0.8 0.4 1.3 0.7 2.2 0.9 2.8 0.4 5.6 2 6.6-2 0 0 0 0 0.3-0.1 2.8-2 5.3-3.9 7.8-6.2 1.9-2.1 3.5-3.9 6-6.4 1 4.5 2.9 4.3 5.3 1.9 0.4-0.4 1.4-0.9 1.7-0.7 3.7 3.3 4.9-1 7.2-2.3 1.5-0.8 3.4-1 5.7-1.6 0.4-1 0.9-3.3 2.2-4.8 1.1-1.2 3.4-2.4 4.7-2.1 3 0.7 5.7 2.5 8.2-0.5 2.8-3.4 3.6-7 1.8-11.2-1.2-2.5-2.1-5.2-3.1-8.1-0.3-1.2-0.6-2-0.5-2.9 2.4-2.2 5.6-4.2 6.1-6.8 0.4-1.7-3-4.2-4.7-6.7-3.3-1.9-6.6-3.5-9.7-5.3 7.3-2.8 7.5-3.5 3.6-10.4-0.5-0.8-0.4-1.9-0.3-2.9 0.1-1.7-0.1-3.4-0.3-5.3-0.1-0.6-0.1-0.8 0.2-1.1 0.7-0.8 1-1.7 1.6-2.7 0.6-1.7 1.1-3.3 1.2-4.8 0-10 0-20 0-30 0-1.5 0.3-3 0.4-4.5q0.9-0.2 1.8-0.3c0.6 2.4 1.5 4.7 1.7 7.1 0.9 9.7 1.4 19.4 2.2 29.2 0.1 0.8 1.1 1.7 1.8 2.5 0.2 5 0.5 10.1 0.9 15.9 0.9 2 1.5 3.3 2.2 4.6 1.9 3.7 5.4 7.3 5.7 11.2 0.8 11 0.7 22.1 0.4 33.2-0.2 4.7-2 9.5-3 14.2 0 0-0.1-0.1-0.4 0-1.4 2-2.5 4-3.6 6 0 0 0-0.1-0.2 0-0.5 0.2-0.8 0.5-0.9 0.8-0.3 0.2-0.6 0.4-1.2 0.9-0.6 0.7-0.7 1-0.7 1.3 0 0-0.1-0.1-0.3 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0 0-0.3-0.1-1.4 1.1-2.5 2.1-3.7 3.1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.4 0.4-0.6 0.7-0.8 1 0 0 0-0.1-0.2 0-0.5 0.2-0.7 0.5-0.8 0.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m407.9 376c-0.2-1.7-0.5-3.5-0.6-5.8-0.1-1.1-0.2-1.6-0.4-2.2q-3.1-20.6-6.2-41.3c-0.6-3.9-1.1-7.9-1.3-12.3 1.8-1.4 4.4-2.5 4.4-3.5 0.1-10.1 6.5-16.1 13.6-22 6.9-0.3 13.3-0.6 19.7-0.9 11.7 4.6 23.2 9.2 36.3 7.3 4.8-0.6 9.8 0.7 15.3 1.2-1.3 1.4-2.2 3-3.5 3.7-9.5 5.2-9.3 14.5-10.1 23.3-0.3 2.5-0.1 5-0.2 8.3-4.1 8.6-8 16.3-11.9 24.1-3.8 7.9-6.1 15.9-6.2 24.9-0.2 10.9-1.9 21.7-2.6 32.6-0.4 5.9-1 12 0 17.7 1.2 6.9-0.8 11.7-5.3 16.6-6.5 7.2-13.6 14.2-14.2 25-0.2 3.2-2.8 5.2-6.6 3.9-2-0.7-4.2-1.1-6.3-1.6-3.2-2-6.5-4.1-9.8-6.9-0.4-4-0.7-7.1-1-10.3 0-5.2 0-10.4 0.1-16.6-0.4-4.4-0.7-7.8-1.1-11.3 0 0-0.1-0.3 0.1-0.9 0.4-6.4 0.6-12.2 1-18.4 1.4-12.1 2.8-23.9-0.1-36-0.3-1.7-0.6-3.1-1-5.1-0.9 2.7-1.5 4.6-2.1 6.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m422 475.4c1.9 0.1 4.1 0.5 6.1 1.2 3.8 1.3 6.4-0.7 6.6-3.9 0.6-10.8 7.7-17.8 14.2-25 4.5-4.9 6.5-9.7 5.3-16.6-1-5.7-0.4-11.8 0-17.7 0.7-10.9 2.4-21.7 2.6-32.6 0.1-9 2.4-17 6.2-24.9 3.9-7.8 7.8-15.5 11.9-23.7 1.6 0.7 3.5 1.4 4.5 2.7 7 10.2 12.4 21.3 14.7 33.6 2.8 15.2 5.9 30.4 8.7 45.6 1.3 7.1 2.1 14.3 3.4 21.4 0.3 2.2 1.6 4.2 2.5 6.3 6.9-3.9 7.8-3.8 8.8 2.5 2.1 13.3 3.8 26.7 5.4 40.1 0.2 1.9-0.6 3.9-1.3 6.3-3.2 3.8-6.3 4.6-9.7 1.3 0 0 0.1 0 0.1-0.3-0.4-0.7-0.8-1.2-1.2-1.7-2.4-5.3-4.8-10.7-7.7-17.2-2.4 2.3-4.1 3.9-5.7 5.6-1.2 1.2-2.1 2.6-3.1 3.9-7.7 9-13 4.5-17.2-4.4-2-4.4-2.6-9.6-4.1-14.2-1-3.1-2.7-5.9-4.5-9.9-3.8 5.5-3.9 10.5-4.4 15.5-1.8 16.7-3.3 33.5-5.2 50.2-0.1 1.5-1.5 2.9-2.4 4.4-1.3-1.4-3.4-2.5-3.9-4.1-1.2-4.4-1.6-9-2.6-13.5-0.7-2.8-1.9-5.6-3.3-9.6-6.7 8.5-5.8 20.5-17 24.7-3.9-15.4-8.1-30.1-7.7-46z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m320 335.2c0.3 1.5 3.3 3.5-1.1 4.6-1 0.9-1.8 1.4-2 2-1.7 6.5-3.2 13-4.8 19.5-2 7.6-4.1 15.1-6.1 22.7-1.6 2.5-3.7 4.7-4.6 7.4-3.7 11-7 22.1-10.6 33.1-1 3-2.7 5.9-3.9 8.9-2.4 6.1-4.7 12.1-6.9 18.2-1.3 3.6-3.1 6.4-7.8 7-0.3-3.9-0.5-7.4-0.5-11.6-0.6-6.3-1.4-11.9-2.4-17.4-0.6-3-1.6-5.8-2.5-9.1-0.8-4.8-1.5-9.1-2.1-13.9-1.5-10.8-3.1-21.2-4.4-31.8 0.1-5.8 0.3-11.4-0.4-16.9-0.5-3.3-2.3-6.5-3.7-10.2-0.2-1.8-0.2-3.2 0-5 0.3-2.1 0.4-3.9 0.5-5.8 0.7-17.7 0.2-35.6 2.3-53.1 1.8-15.1 6.4-29.8 9.9-44.6 0.9-3.9 2.3-7.7 3.7-11.5 0.7 0.1 1 0.2 1.4 0.7 1.1 2.9 2.1 5.5 3.1 8.5 0.1 3-0.3 5.6 0.5 7.9 3.7 12.2 7.3 24.5 11.8 36.3 5.8 15.3 15.6 27 32.7 30.4 3.6 0.7 3.1 3 2.4 5.7-1.7 5.9-3 12-4.5 18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m103.8 307.9c0.4-8.6 0.8-17.1 1.5-26.2 0.2-0.4 0.6-0.6 0.6-0.6 5.6 6.5 13.4 8.5 21.1 10.9 2.8 0.9 5.5 1.9 8.7 3.1 7.9 7 13.6 15 17.1 24.2 5.6 14.4 4.7 29.5 3.9 44.4-0.8 17.4-2.5 34.7-3.7 52-0.6 8.7 2.3 16.6 5.9 24.2 0.7 4.6 0.9 9.3 2.1 13.8 1.8 7.1 3.2 14.3 0.8 21.4-0.9 2.7-3.2 5.2-5.5 7.1-1.9 1.6-4.7 2.3-7.1 3.4-7.8 3.4-15.6 7.1-23.5 10.3-7.3 3-14.8 5.4-22.3 8-10.4 3.5-20.7 7.7-31.4 10.4-12.7 3.4-25.1 2-36.4-5.9-7.5-5.2-10.2-13.1-12.5-21.3-0.8-2.6-0.7-5.5-0.8-9 0.5-6 0.4-11.3 0.8-16.5 0.1-1.6 1.2-3.2 2.1-5.5 1.7 3.6 2.8 5.8 3.8 8.3 0.1 1.1 0 1.8-0.2 2.8 0.2 1.4 0.6 2.6 1.2 4.2 0.7 2.8 1.4 5.2 1.8 7.8 0.4 3 0.3 6.4 2 8.3 1.1 1.3 2.3 6.2 6.4 2.9 0.2 0 0.6 0 0.7 0.2 0.4 0.5 0.7 0.6 1.2 0.8 1.6 1.1 2.9 2.1 4.4 2.5 8.1 1.9 16.1 0.9 23.9-1.4 7.1-2.2 14-4.9 18.6-11.6 0.2-0.1 0.2-0.4 0.5-0.6 2.4-3.8 4.6-7.4 6.9-10.7 1.8 4.8 3.5 9.2 4.9 13 11.1-1.3 13.8-9.4 16.5-16.7 3.1-8.3 5.1-17 7.2-25.7 2.2-9.1 4.4-18.3 5.9-27.5 3.5-22.9 7.1-45.8 9.7-68.7 0.8-7.8-0.8-15.9-2-23.7-0.2-1.7-3.6-3.8-5.8-4.1-6-0.7-8.8 4.3-12 8.2-1.4 1.7-3.2 3.1-4.8 4.2-2.4-6-4.5-11.6-7.2-17-0.8-1.7-3.3-2.5-5-3.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m260 375c1.6 10.4 3.2 20.8 4.3 31.6-0.7 1.9-1.4 3.4-1.3 4.8 0.6 9.1-0.8 10.3-8.6 6.7-0.2-0.1-0.3 0-0.5 0 0 0 0.1-0.1-0.1-0.3-0.4-0.4-0.7-0.6-0.9-0.8 0 0-0.5 0-0.8-0.3-0.6-0.4-0.9-0.6-1.2-0.6 0 0 0.1-0.1 0.1-0.4-0.8-5.2-5.3-8.3-12.1-8.7-3-0.3-6.1-0.6-9.7-1.2-2.7-1.1-4.9-1.9-7-2.8-0.1-0.4-0.2-0.9 0-1.8-0.6-2.8-1.3-5-2-7.2-0.1-2.7-0.1-5.4 0.1-8.8 0.2-2.2 0-3.7-0.1-5.2-0.1-3.4-0.1-6.7 0.1-10.8 0.4-1.2 0.5-1.8 0.7-2.3 0-1.7 0-3.4 0.2-5.6 0.4-0.8 0.3-1.1 0-1.3 0 0-0.2-0.4-0.3-0.9-0.3-0.7-0.5-0.9-0.8-1.1-1.3 1.4-3.4 2.6-4 4.3-3.2 9.3-6.1 18.6-9.4 28.6-0.4 1.5-0.5 2.4-0.7 3.2 0 0 0 0.5-0.4 0.9-1.1 5-1.8 9.5-2.5 14.1 0 0-0.1-0.1-0.4-0.1-1.4 0-2.5 0-3.5 0-0.1-1.1-0.1-2.2 0.1-4 0.5-9.8 0.6-19 0.7-28.1 0.6-5.7 1.3-11.4 2.4-17.6 1.2-3.8 2.6-7.1 2.4-10.3-0.3-2.8-2.5-5.3-3.9-8.3 0.2-1.2 0.3-2.1 0.7-3.1 0.5-1 0.7-1.8 1.2-2.9 0.9-2.1 1.5-3.9 2.4-6 9.7-21.6 19-43.1 28.7-64.3 2.8-6.1 6.8-11.8 10.9-17.1 5.6-7.2 11.7-13.9 17.6-20.9 0 0 0 0 0.2-0.2 0.3-0.5 0.4-0.8 0.4-1.1 0 0 0.5 0 1 0 1-0.3 1.5-0.7 2.3-1 2.6 0 6-2.4 5.3 2.8-4.2 8.6-8.5 17-11.8 25.8-11.3 29.6-11.1 59.9-3.9 90.3 0.1 1.5 0.1 2.9 0.2 5.2 1.4 9.5 2.6 18.1 3.9 26.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m156 265c1.1-5.1 5.6-5.9 9.2-5.8 21.1 0.4 38.7-8.9 56-19.3 3.9-2.3 8.1-4.4 12.6-6.6 0.7-0.1 0.9-0.2 1.2-0.3 0 0 0.5 0 1.1 0 4.6-0.8 8.5-1.7 12.5-2.5q0.5 0.5 0.9 1.1c-1.2 1.7-2.2 3.7-3.8 5.1-6 5.1-9.3 11.5-11.1 19.3-1 3.7-4.6 6.9-7.1 10.2-1 1.3-2.3 2.4-2.9 3.8-3.7 9.1-7.1 18.4-11 27.5-4.7 11.4-9.8 22.6-14.8 34-0.4 1.1-0.4 2.3-0.7 3.8-0.1 0.4-0.1 0.6-0.5 0.9-2.7 5.6-5.2 11.2-7.8 17.1-2.9 6.1-5.5 12-8.6 17.9-0.9 1.4-1.6 2.6-2.6 3.9-1.1 1.7-1.8 3.3-2.6 5.2 0 0.2 0 0.7-0.4 0.7-1.7-0.3-3.1-0.7-4.5-1.4 0.6-3.1 1.3-5.9 2.2-8.6 0.4-0.7 0.5-1.4 0.7-2.5 0-2.1-0.2-3.8 0.1-5.4 2.9-14.1 0.3-28.1-2.7-41.7-3.2-14.5-7.7-28.6-7.5-43.7 0.1-6.2-3.4-10.2-7.8-10.8 0 0 0-0.4-0.1-0.9 0-0.7 0-0.9 0-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s8",
    d: "m266 224c-0.5 0.4-1 0.8-1.8 1.1-0.9-2.2-1.6-4.2-2.2-7 0.3-2.2 0.7-3.6 1.4-5 6.4 1.1 12.4 4.2 18.4-0.6 0.9-0.8 3.3-0.6 4.7 0 7.9 3.3 15.7-0.3 18.3-9.1-8.1 3-7.6-4-8.9-6.7-7.5-2.7-12.6-0.3-18 3.8-2.5 1.9-7.5 3.7-11-1.1-0.9-1.2-3.9-1-6.3-1.4-3-0.1-4.4-0.4-2.3-3.4 1.4-2.3 1.3-4.8-2.6-5.5-0.5 2-0.9 3.7-1.4 5.7-4.1-3.1-4.9-11.5-2.1-18.5 1 0.8 1.9 1.2 2.9 2 0.7 0.8 1.3 1.3 1.8 2 0.1 0.2 0.1 0.7 0.2 1 1.9 2.5 1.2 7.1 6 6.9 4.9 6.4 8.8 7.2 16.1 4.1 4.5-0.6 8.7-1.5 13.2-2.3 1.1 0 1.9 0 2.8 0.3 1.7 1 3.2 1.9 4.8 2.7 0 0 0 0 0 0.4 2.5 2.7 5 4.8 8.5 2.5 2.3-1.5 4.3-3.3 6.9-5 2.5-2 4.8-3.9 7.2-5.7 1.1 0.1 1.8-0.1 2.9-0.2 1.4-0.3 2.4-0.5 3.8-0.8 0.8 0.1 1.3 0.1 2 0.3 1-0.1 1.8-0.3 3-0.5 1.2 0 2-0.1 3 0.2 1-0.2 1.9-0.7 3.2-1.2 1.9-0.8 3.3-1.8 4.9-2.6 7.8-3.8 9.8-7.3 9-15.7 1.2-2 2.2-3.9 2.8-5.8 1.3-3.9 2-8 3.7-11.7 1.9-4.2 4.3-8.1 6.9-11.8 2-3 4.3-5.9 7.1-8.2 5-4.1 7.2-8.9 5.3-15.3-1-3.8-2.6-7.5-4.4-11-7-13.3-11.2-28.7-25.9-37.1-1.3-0.7-2.5-1-3.9-1.3-0.5 0-0.8-0.2-1-0.8-3-5.4-8-7.1-13.3-7.6-4-0.4-7.5-1.3-9.6-5.3 1.9-0.1 3.6-0.1 5.2 0.2 2.3 0.3 4.9 1.7 6.8 1.1 3.2-1.1 6-3.3 9.3-5.1 2.8-0.9 5.2-1.9 7.6-2.8 2.1-0.1 4.3-0.7 6.2-0.1 2.6 0.9 5 2.7 8.4 4.6-3 0.2-5.1 0.4-8 0.6 1.7 1.1 2.6 2 3.7 2.4 9.4 2.6 13.7 10.9 19.7 17.3 1 1.1 1.9 2.2 2.6 3.7-3.2 0.1-6.1-0.1-9.7-0.3 0.8 2.7 0.8 5.5 2.2 7 5.6 5.9 7.8 13.5 10.5 20.6-1.6-0.5-2.8-1-4-1.4 1.1 6.5 2.3 12.6 3 18.8 0.4 3.9-0.1 8-0.4 12-0.1 1.6-0.8 3.1-1.2 5.1-0.3 1.6-0.7 3-1.5 4.3-2.2 0.9-4.8 1.1-5.9 2.5-5.3 6.7-8 14.5-7.4 23 0.1 2 2.2 3.9 3.5 6.2 0.5 0.5 0.8 0.8 1.2 1.3 0.4 0.9 0.8 1.6 0.9 2.4-2.4 2.9-5.5 5.8-3.3 9.3 0.8 1.4 4.4 1.1 6.7 1.5-8.1 5.8-13.1 13.7-16.8 22.6-0.6-0.8-0.8-1.5-1.3-2.7-1.2 2.9-2.2 5.1-3.5 7.2-0.7 0-1.1 0-1.8 0.1-0.2 0.7-0.1 1.3 0 2.2-2.5 3.4-6 4-9.7 4.6-8.6 1.3-17.1 3.2-25.7 4.9q-5.4 1.1-10.9 2.4c-2 0.4-3.9 1.2-5.8 1.7-1.7 0.4-3.5 0.6-5.2 0.9q-0.1 0.8-0.2 1.6c-3.4-2.2-6.8-4.3-10.6-6.5-1.9 0.7-3.3 1.4-5.1 2-1.8-0.4-3.1-0.8-4.5-1.4 0-0.2-0.1-0.7-0.3-0.9-0.7-0.4-1.2-0.5-1.9-1-1.5-0.7-2.7-1.2-4.2-2-3.9-1.6-3.7 1-3.9 3.5-0.4 0.7-0.6 1.3-0.8 1.8zm51.4-8.7c7.2 2.4 12.2 1.6 14.7-4.1q-4.7 1.1-9.3 2.1c-8.2-1.7-11.4-0.9-15.2 6.3 3.8-1.9 6.4-3.2 9.8-4.3zm46.2-29.9c-1.4-0.9-2.8-1.9-4.3-2.9-1 3.9-2.3 6.6-2.3 9.3 0.1 2.7-6.2 3.2-1.7 7.8 3-4.9 5.6-9.2 8.3-14.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m417 289c-6.7 5.8-13.1 11.8-13.2 21.9 0 1-2.6 2.1-4.3 3.1-4.7-5-15-6-20.3-2-1.6 1.2-3 2.7-4.4 4.1-2 2.1-3.7 2.1-6.5 0.7-3.5-1.8-7.6-3-11.6-3.2-5.4-0.3-9.5-1.4-12.1-6.7-2.4-4.8-3.9-4.6-11.1 0 1.1-6.9 2-13.7 4.4-19.8 2.2-5.8 5.3-11.8 9.4-16.2 7.3-7.8 6.9-17.8 10.1-27 1-1 1.7-2 1.9-2.3 10.1 4.8 20.1 9.6 30.1 14.3 1.5 0.7 3.2 0.7 4.7 1.1 0 0 0.5 0 0.9 0.3 1 0.4 1.5 0.5 2.1 0.6 0 0-0.1 0-0.1 0.4 3 2.4 6.1 4.5 9.1 6.6 0 0-0.1 0.1-0.1 0.4 1 1.1 2.1 1.9 3.1 2.6 0 0-0.1 0 0 0.3 0.3 0.5 0.5 0.7 0.9 0.8 0 0 0 0.5 0.1 0.9 0.4 0.7 0.7 0.9 1 1.1 0 0-0.1 0 0 0.2 0.4 0.4 0.7 0.6 1 0.8 0 0-0.1 0-0.1 0.4 0.2 4.4 2.8 5 6 4.5 0 0 0 0.1 0.1 0.3 0.4 0.5 0.6 0.7 1 0.7 0 0-0.1 0.1 0 0.3 0.4 0.4 0.7 0.6 1 0.8 0 0-0.1 0 0 0.2 0.4 0.4 0.7 0.6 1 0.8 0 0 0.5 0 0.8 0.3 0.6 0.5 0.9 0.6 1.2 0.7 0 0 0.5 0 0.8 0.3 0.6 0.5 0.9 0.6 1.2 0.7 0 0 0.4 0.1 0.7 0.5-1.8 7.5-6.3 0.7-9.7 2.1 0.3 1.6 0.6 3 0.9 4.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m179 375c0.6-1.2 1.3-2.4 2.2-3.3-0.8 6.6-1.9 13-3 19.3q0.7 0.1 1.4 0.3c4.2-12.8 8.3-25.5 12.6-38.6 2.1-5.7 3.9-11.2 5.8-16.6 0-0.2 0-0.4 0.4-0.9 1.4-1.9 2.3-3.6 3.5-5 0.7-0.7 2-0.8 3.1-1.2-0.7 1.8-1.3 3.6-2.5 5.8-0.8 1.3-0.9 2.1-1.1 3-0.2 0.8-0.3 1.7-0.7 3.1-0.7 2.5-1.2 4.3-1.7 6.1-2.6 6.9-5.5 13.7-7.7 20.7-3.7 12-7 24.1-10.2 36.2-2 7.5-3.5 15.1-5.2 22.7-1.4 6.5-9.9 13.4-16.7 13.2-3.9-7.5-6.8-15.4-6.2-24.1 1.2-17.3 2.9-34.6 3.7-52 0.8-14.9 1.7-30-3.9-44.4-3.5-9.2-9.2-17.2-16.7-24.2 3.9-2.6 8.1-4.5 11.8-7.1 4.1-2.7 7.9-5.8 11.4-9.2 0.9-0.9 0.2-3.7-0.3-5.5-0.7-2-2-3.8-2.9-6 4.4 0.2 7.9 4.2 7.8 10.4-0.2 15.1 4.3 29.2 7.5 43.7 3 13.6 5.6 27.6 2.7 41.7-0.3 1.6-0.1 3.3-0.4 5.6-0.4 1.2-0.5 1.7-0.7 2.3-0.6 2.7-1.3 5.5-2 9 0 3.3 0 5.7 0 8.1q0.7 0.2 1.4 0.4 1.8-3.7 3.6-7.5c0 0 0-0.5 0.3-0.8 1.2-2 1.9-3.6 2.7-5.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m277.1 222.8c1.4 0.4 2.7 0.8 4.5 1.6 1.2 0.8 2.5 1.7 2.7 1.6 1-1.2 1.9-2.6 2.8-4q5.1 3.3 10.2 6.5 0.1-0.8 0.2-1.6c1.7-0.3 3.5-0.5 5.2-0.9 1.9-0.5 3.8-1.3 5.8-1.7q5.5-1.3 10.9-2.4c8.6-1.7 17.1-3.6 25.7-4.9 3.7-0.6 7.2-1.2 9.8-4.9 0.1-1.1 0.1-1.6 0.1-2 0.5 0 0.9 0 1.7 0.4 0.7 1.8 1 3.2 1.3 4.6 0.3 6.7 0.6 13.3 0.6 20.4-1.2 1.1-1.9 1.8-3 2.6-1.8 2.4-3.6 4.6-4.7 7.1-4.5 10.2-16.2 16.7-27 14.2-14.7-3.3-28-9.8-39.5-19.5 0.4-0.1 0.6-0.2 0.6-0.3 0.1-0.1 0.2-0.4 0.1-0.5-3-4.4-6-8.8-9-13.5 0.3-1.2 0.7-2 1-2.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m74 244c-0.5-0.2-1-0.5-1.8-1.1-3.6-0.3-6.9-0.1-10.2 0.1-1.4 0-2.8 0-4.8-0.2-1.5-0.4-2.4-0.6-3.2-0.7-2.2-1.9-4.3-3.8-6.8-6.3-1.9-3.9-3.5-7.4-5.2-11.2 1-3.2 2.6-6 2.8-8.9 0.3-3.6-0.5-7.2-0.8-10.8 3.3-9.2 4.2-18.8 4.8-28.7 0.8-0.2 1-0.2 1.1 0.3 0.7 6.8 1.4 13.2 1.9 19.7-0.4 1.1-0.5 2-0.6 3.2 0 1.5 0 2.5 0 4 1.1 4.8 1.6 9.5 6.7 12 1.1 1.9 2 3.5 3 5.3 0.7 1.3 1.4 2.4 2.1 3.7 0.4 0.4 0.7 0.4 1.3 0.5 0.2 0 0.6 0.1 0.7 0.5 1.5 2.4 2.9 4.5 4.8 7.3 2-2.3 3.6-4.3 5.6-6.3 0.5-0.3 0.6-0.5 0.9-0.9 0.3-0.3 0.5-0.5 1-0.6 6.8-3.7 13.3-7.4 20.1-11.2 3.7-0.7 7.2-1.2 10.8-1.5 1.1 0 1.9-0.2 3.2-0.4 1.9-0.5 3.6-1 5.6-1.3 5.8 0.1 7.1-1.8 6.4-9.2 0.3-0.6 0.4-1 1-1.4 1.7 0.1 3.1 0.2 4.4 0.3 1 2.6 1.9 5.3 3.1 7.8 1.8 4.2 1 7.8-1.8 11.2-2.5 3-5.2 1.2-8.2 0.5-1.3-0.3-3.6 0.9-4.7 2.1-1.3 1.5-1.8 3.8-2.2 4.8-2.3 0.6-4.2 0.8-5.7 1.6-2.3 1.3-3.5 5.6-7.2 2.3-0.3-0.2-1.3 0.3-1.7 0.7-2.4 2.4-4.3 2.6-5.3-1.9-2.5 2.5-4.1 4.3-6.3 6.4-4.6 0.3-6.6 2.8-7.8 6.3 0 0 0 0-0.4 0-2.9-0.8-5.3-1.2-6.6 2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m124.5 156c-0.3 0.8-0.6 1.7-1.5 2.5-0.7 0.1-0.9 0.2-1 0.4 0 0.1 0.1 0.1 0.4-0.2-2.6-3.8-5.5-7.3-8.7-10.9-0.7-0.2-1.1-0.3-1.5-0.8 0-11.8 0-23.2 0-34.6-1.5-0.1-2.3-0.4-2.9-0.3-12.9 3.4-26 6.8-38.9 10.4-1.1 0.3-2.3 2.3-2.4 3.7-0.5 6.3-0.7 12.6-1.3 18.8-1.5-1-2.6-2-4-3-0.2 0-0.7 0.2-0.9 0.1-0.5-0.2-0.7-0.1-0.9-0.1 0 0 0.1 0 0.2-0.3-0.1-0.5-0.2-0.9-0.3-1.7 0.8-8 1.5-15.5 2.2-23.1 6.1-6.3 15.1-6.5 23.1-10.5 6.4-2 12.1-3.7 18.2-5.4 0.8-0.3 1.3-0.6 2.1-1 2.4-0.6 4.5-1.1 6.9-1.5 2.2 0.3 3.9 0.5 5.7 0.8 0.1 0.1 0.3 0 0.5 0.3 1.8 3.3 3.3 6.4 4.7 9.9 0 15.8 0.2 31.2 0.3 46.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m29 464c-1-2.1-2.1-4.3-3.8-7.9-0.9 2.3-2 3.9-2.1 5.5-0.4 5.2-0.3 10.5-0.7 16-1-14.6-1.8-29.6-2.4-44.6-0.5-13.5-1.4-26.9-0.9-40.3 0.7-15.8 3.6-31.3 8.2-46.5 3.3-11 5.9-22.3 9.2-33.8 1.3 0.2 2.1 0.7 2.9 1.6-1.4 11.3-2.8 22.1-4.3 33.3-0.1 0.8-0.1 1.3-0.3 2-0.6 2.8-1 5.3-1.5 8.1-0.2 1.5-0.2 2.5-0.5 3.8-0.3 1.1-0.3 2-0.5 3.2-0.2 1.1-0.2 1.9-0.5 2.9-0.6 3.8-1 7.3-1.6 11-0.1 0.8-0.1 1.3-0.3 2-0.3 2.2-0.5 4-0.7 6.1-0.2 1.1-0.2 1.8-0.4 2.8-0.3 1.2-0.3 2-0.5 3.2-0.1 1.1-0.1 1.9-0.3 3-0.2 2.1-0.4 3.9-0.6 6-0.1 1.1-0.1 1.8-0.3 3 0.3 16.1 0.7 31.9 1 48 0.4 2.8 0.7 5.2 1 8-0.1 1.5-0.1 2.5-0.1 3.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s15",
    d: "m375.1 172c-0.4-0.6-0.8-1.3-0.9-2.3 2.3-2.2 4.3-3.9 6.4-5.8-0.2-0.1 0.2 0.2 0.5 0.5q2.4 2.2 4.8 4.4c1.4-2.1 2.8-4.2 4.1-6.3 0.4-0.7 0.7-1.6 0.7-2.4-0.2-1.7-0.6-3.3-0.8-4.9-1.4 0.7-2.9 1.2-4 2.2-2.7 2.2-4.5 2.7-5.3-1.7-0.2-0.9-2.4-2.4-3.4-2.2-4.3 0.8-7.1 6.9-5.6 11 0.5 1.2 0.7 2.5 0.9 3.7-1.1-2-3.2-3.9-3.3-5.9-0.6-8.5 2.1-16.3 7.4-23 1.1-1.4 3.7-1.6 6.3-2.4 4.3-1.1 7.8-2.3 11.6-3.3 1 0.1 1.7 0.1 2.6 0.2 0.3 0.1 0.7 0.2 0.7 0.2 11.1 4.4 10.1 18.5 2.9 26.7-4.4 5-9.7 9.2-14.5 13.8-1.9 1.7-3.6 3.7-5.8 5.2-0.2-4-1.8-6.5-5.3-7.7zm21.6-11.5c1.7-4.6 3.9-9.1 4.9-13.8 1-4.3-2.1-7-6.5-6.5-1.6 0.2-3.5 0.4-4.7 1.4-3.7 2.7-7.1 5.8-10.6 8.8q0.6 0.9 1.1 1.9c2.3-1 4.7-1.9 6.9-3 2.3-1 4.3-2.4 6.5-3.5 0.8-0.3 2.5-0.4 2.7 0 0.5 0.8 0.8 2.3 0.4 3.1-1.1 2.6-2.8 4.9-3.9 7.5-0.9 2.2-1.6 4.8 3.2 4.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m205.2 328.7c-1.3 0.7-2.6 0.8-3.3 1.5-1.2 1.4-2.1 3.1-3.4 4.8-0.1-1.2-0.1-2.4 0.3-3.5 5-11.4 10.1-22.6 14.8-34 3.9-9.1 7.3-18.4 11-27.5 0.6-1.4 1.9-2.5 2.9-3.8 2.5-3.3 6.1-6.5 7.1-10.2 1.8-7.8 5.1-14.2 11.1-19.3 1.6-1.4 2.6-3.4 3.8-5.1q-0.4-0.6-0.9-1.1c-4 0.8-7.9 1.7-12.3 2.5 5-1.7 10.3-3.5 15.7-5 3.1-0.9 6.4-1.2 10-1.7-5.5 7.1-11.6 13.8-17.2 21-4.1 5.3-8.1 11-10.9 17.1-9.7 21.2-19 42.7-28.7 64.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m387 98c-3.1-7.1-5.3-14.7-10.9-20.6-1.4-1.5-1.4-4.3-2.2-7 3.6 0.2 6.5 0.4 9.8 0.6 7.7 8.3 9.6 19 12.7 29 1.6 5.2 1.8 10.7 2.7 16.7 0.3 0.9 0.5 1.1 0.7 1.3 0.1 1.1 0.1 2.1-0.1 3.8-0.4 0.8-0.6 1-0.7 1.3 0 0.7 0 1.5-0.4 2.6-1.8 2-3.2 3.7-5 5.3-2.2 0.3-3.9 0.7-5.6 0.6 1.3-3.5 3.4-6.6 3.5-9.8 0.2-5.2-0.8-10.4-1.7-15.5-0.5-2.9-1.9-5.5-2.8-8.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m306 384.4c2-8 4.1-15.5 6.1-23.1 1.6-6.5 3.1-13 4.8-19.5 0.2-0.6 1-1.1 1.7-1.8 0.5 2 1.1 4.1 0.6 6-6 21.6-12 43.2-18.4 64.7-4.4 15-9.5 29.8-14.4 44.7-0.8 2.6-2.1 5.2-3.2 8.1-1.6 2.1-3.1 3.9-4.6 5.6q-0.3-0.1-0.6-0.3c9.3-28 18.6-56 28-84.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m62 142.2c0 0 0.5-0.2 0.7 0.3 0.8 3.8 1.3 7.2 1.8 10.8-0.2 0.8-0.2 1.2-0.3 2-0.5 1.9-0.8 3.6-1.2 5.2-1.7 6.8-3.5 13.6-5.5 20.5-0.3 0.8-0.3 1.4-0.3 2.4 0 0.7 0 1.1-0.3 1.6 0.1 7.4 0.6 14.7 1.1 22.3-0.1 0.8-0.4 1.3-1.1 1.7-2.1-2-3.9-4-5.7-6 0-1.1 0-2.1 0.3-3.7 0.4-1.4 0.5-2.3 0.5-3.3-0.7-6.3-1.4-12.7-2-19.9 0.1-1.2 0.1-1.6 0.5-2.2 0.7-2 1.1-4 1.5-6.4 0.6-3.7 1.8-7.1 1.8-10.5 0.1-5.1-0.5-10.2 5.3-12.9 0 0 0.3-0.1 0.8-0.1 1.1-0.6 1.6-1.2 2.1-1.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m60.9 273.4c0.6 3.2 2.4 7.2 1.4 10.2-3.8 11.7-8.5 23-12.9 34.4-1 2.5-2.2 4.9-3.7 7.6-0.7 0.3-1 0.3-1.4-0.1 1.5-11.5 3.1-22.5 5.1-33.6 1.7-4 3.2-8 4.6-12 0 0 0 0.1 0.2 0 0.4-0.2 0.6-0.5 0.7-0.7 1.9-1.9 3.8-3.7 6-5.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m251 104.9c2.7-6.5 5.5-13.1 8.4-19.5 0.1-0.4 1.1-0.3 2.1 0 0.1 2.1-0.1 3.9-0.4 6-0.2 1.3-0.2 2.3-0.6 3.5-1.1 1.8-2.2 3.3-2.4 5-0.5 6.7-0.7 13.4-1.1 20.4 0 0.8 0 1.3-0.3 2-0.7 6.4-1.2 12.6-1.6 19.1-0.1 1.8-0.1 3.2-0.1 5-0.1 1.8-0.1 3.2-0.1 5-0.3 1.4-0.6 2.6-1.1 3.5-1.1-0.4-1.8-0.6-2.6-0.9 0-0.5-0.1-0.9 0.1-1.9 0.1-2.8-0.1-4.9-0.2-7.5 0.2-2.9 0.4-5.3 0.7-8.1-1.3-0.2-2.5-0.3-4-0.5-0.5 0-0.7 0-0.9 0.1 0 0 0.1-0.1 0.1-0.4 0-0.4 0-0.6 0-0.8 0 0 0-0.5 0.5-0.7 6.9-1.3 7.5-2.1 5.9-8.3-0.5-2-1.4-4-2.4-5.9-1.8-3.4-3.1-6.5-0.6-10.3 0.8-1.2 0.4-3.2 0.6-4.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m330.1 32.9c0 0 0.5 0.1 0.8 0.3 0.5 0.5 0.7 0.7 1 0.8 0 0.4 0.1 0.8 0.2 1.8 0.3 0.8 0.5 1 0.8 1.2 0 0 0.1 0.4 0.1 1 0.5 1.3 0.9 2 1.4 2.8q0.8-1 1.5-2c0.5-0.5 1-1.1 2-1.8 1.1 0 1.5 0 2 0 0.3 0.7 0.7 1.5 1.1 3 0 1.8 0 2.9-0.4 4-10.4 2.1-19.6 0.7-28.3-5.2-0.1 1-0.2 2.1-0.7 3.2-2.6 0-4.6 0-6.7 0 5.3-3.4 1.6-7 0.3-10.8 2.3 0.7 4.6 1.5 7.3 2.3 0.3-1.7 0.5-2.9 0.8-4.7 3.1 2.3 5.9 4.5 8.8 6.5 0.4 0.2 1.3-0.4 2.1-1 0.5-0.7 0.7-0.9 0.8-1.2 0.4 0 0.8-0.1 2-0.1 1.5 0 2.3 0 3.1-0.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m112.9 98.4c-2 0.5-4.1 1-6.5 1.2-0.1-7.2 0.3-14 0.6-20.7 3.1-2.3 6.2-4.6 9.6-6.4 0.8 3.1 1.2 5.8 1.6 9-0.1 4.8-0.1 9.2-0.5 13.6-1.8 1.1-3.3 2.2-4.8 3.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m263 213c-0.3 1.5-0.7 2.9-1 4.7-1.8 0.1-5 0-5.2-0.7-0.6-2.9-1.5-7.5 0-8.8 4.7-4 0.4-6.9-1.4-7.7-5.2-2.6-6.3-7.5-7.9-11.9-0.8-2.2 0.8-5.4 1.3-8.1 0.8-4.7 1.6-9.5 2.8-14 0.4 0.9 0.4 1.7 0.4 2.9 0 1.5 0 2.5 0.1 3.9 0 0.8 0.1 1.2 0.1 1.9-0.1 0.5-0.2 0.6-0.2 0.8-2.6 7.3-1.8 15.7 2.3 18.8 0.5-2 0.9-3.7 1.4-5.7 3.9 0.7 4 3.2 2.6 5.5-2.1 3-0.7 3.3 2.3 3.7 3.9 4.1 5.1 8 1.8 12.5-0.3 0.4 0.4 1.4 0.6 2.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m124.8 155.8c-0.4-15.1-0.6-30.5-0.4-46.1 1.7 0.6 3.1 1.4 4.5 2.3 1.4 5.7 3.4 11.4 4 17.1 0.9 8.3 0.8 16.7 1 25.5-0.7-0.4-1.7-1.3-1.8-2.1-0.8-9.8-1.3-19.5-2.2-29.2-0.2-2.4-1.1-4.7-1.7-7.1q-0.9 0.1-1.8 0.3c-0.1 1.5-0.4 3-0.4 4.5 0 10 0 20 0 30-0.1 1.5-0.6 3.1-1.2 4.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m104 101c-5.8 1.7-11.5 3.4-17.7 5.2-0.4 0-0.5-0.2-0.5-0.5-0.3-0.4-0.6-0.5-0.9-0.7 0 0 0.1 0 0-0.2-0.3-0.4-0.5-0.6-0.8-0.9 0 0-0.2-0.3-0.1-0.8 0.1-0.6 0.1-0.8 0.5-1 9.2 0 11.1-2.4 9.2-10.6-0.7-2.8-1.2-5.7-1.5-8.5 0.9 0 1.4-0.1 1.9-0.1 0 0-0.1 0.1 0 0.3 0.4 0.4 0.8 0.6 1.1 0.8 0 0-0.2 0-0.2 0.3 1.3 2.1 2.6 4 3.9 5.8 0 0 0.2 0.3 0.2 0.7 0.3 0.8 0.6 1 0.8 1.3 0 0 0.2 0.3 0.1 0.9 1.3 3 2.7 5.5 4 8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m355.9 238c0.8-0.7 1.5-1.4 2.6-2.1 4.1 2.4 7.8 5 11.7 7.2 4.2 2.3 8.7 4.2 12.9 6.5 3.7 2 7.2 4.5 10.9 7.1-1.4-0.1-3.1-0.1-4.6-0.8-10-4.7-20-9.5-30.1-14.3-0.2 0.3-0.9 1.3-2 2-0.6-2.1-1-3.9-1.4-5.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m250.6 104.9c0.2 1.6 0.6 3.6-0.2 4.8-2.5 3.8-1.2 6.9 0.6 10.3 1 1.9 1.9 3.9 2.4 5.9 1.6 6.2 1 7-5.8 8.1 1.7-6.3-2.7-12.1-1.8-18.5 0.5-4.2 1.6-7.6 4.8-10.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m53.6 279.9c-1 4-2.5 8-4.6 12-3.7 7.3-6.6 14.5-9.6 21.7-0.8-0.5-1.6-1-2.9-1.6 2.9-9.9 5.6-20 12.4-28.2 1.3-1.5 2.9-2.6 4.7-3.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m140.4 234c0.7-4.6 2.5-9.4 2.7-14.1 0.3-11.1 0.4-22.2-0.4-33.2-0.3-3.9-3.8-7.5-5.7-11.2-0.7-1.3-1.3-2.6-2-4.3 6.4 4.6 10 11 10 19.2 0 10.8 0.4 21.6-0.2 32.4-0.2 3.7-2.6 7.3-4.4 11.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m253.9 418.4c0.2-0.3 0.3-0.4 0.5-0.3 7.8 3.6 9.2 2.4 8.6-6.7-0.1-1.4 0.6-2.9 1.2-4.4 1.1 4.4 1.8 8.7 2.3 13.7-0.4 2.8-0.5 5-0.6 7.2-0.8 0.9-1.7 1.8-3 3.2-3-4.1-5.9-8.2-9-12.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m128.9 111.6c-1.4-0.5-2.8-1.3-4.4-2.4-1.7-3.2-3.2-6.3-4.5-9.7 1.4-0.4 2.6-0.5 4.3-0.5-0.4-7.1-0.7-13.7-1.1-21-2.3 1.4-3.6 2.2-4.9 3.1-0.5-2.8-0.9-5.5-1.3-8.6 5.1-0.4 7.8 2.4 8 8.2 0.1 4-0.5 8 0.1 11.9 1 6.3 2.6 12.4 3.8 19z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m374.8 172.2c3.8 1 5.4 3.5 5.2 7.5-0.1 0.7-0.3 1-1 1.5-0.7 0.8-0.8 1.3-1 1.9 0 0 0.1-0.1 0.1-0.1-2.2-0.4-5.8-0.1-6.6-1.5-2.2-3.5 0.9-6.4 3.3-9.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m417.4 288.9c-0.7-1.3-1-2.7-1.3-4.3 3.4-1.4 7.9 5.4 9.9-2.1 3.6 1.4 7.2 3.1 10.9 5.2-6.2 0.6-12.6 0.9-19.5 1.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m266.2 428.2c-0.2-2.5-0.1-4.7 0.3-7.1 1.2 2.7 2.2 5.5 2.8 8.5 1 5.5 1.8 11.1 2.5 17-1.4-3.5-2.7-7.3-3.8-11.1-0.6-2.3-1-4.7-1.8-7.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m104.3 101c-1.6-2.5-3-5-4.3-7.9 2.4 0.7 3.9 0.9 4.1-2.7 0.2-3.8 1.4-7.4 2.5-11.3 0.1 6.5-0.3 13.3-0.6 20.5-0.4 0.8-0.9 1.1-1.7 1.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m411 411c-0.3 5.8-0.5 11.6-0.8 17.8-0.9 2-1.6 3.5-2.7 5.9-0.4-2.1-0.5-3.2-1.1-4.5 0.4-5.2 1.1-10.4 2.1-16 0.7-1.3 1.1-2.3 1.8-3.2 0.2 0 0.7 0 0.7 0z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m46.9 124.1c-3.2-3.6-3.5-7.5-0.8-10.6 2.7-3.2 6.2-3.4 10.3-0.6 1.7 1.3 3.3 2.6 5.3 4.3 0.2 0.6-0.1 0.9-0.7 1-2.1-1.2-3.9-2.5-5.8-3.4-1.5-0.7-3.8-1.8-4.7-1.2-1.9 1.3-3.4 3.5-4.3 5.6-0.5 1.3 0.5 3.2 0.8 4.8 0 0-0.1 0.1-0.1 0.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m60.8 140.4c0.1 0.4 0.2 0.8 0.3 1.4-4.4-0.2-8.8-0.8-13.2-1.3-0.2-4.3-0.6-9.9-0.9-16-0.1-0.4 0-0.5 0.4-0.4 1 3.7 1.6 7.3 2.3 10.9 0.3 1.3 1 2.6 1.6 3.9 2.3-1.5 5.8 2.4 7.5-1.5 0.7 1.3 1.4 2.2 2 3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m58.7 144.1c-5.4 2.7-4.8 7.8-4.9 12.9 0 3.4-1.2 6.8-2.1 10.7-0.7 0.8-1.2 1.1-1.7 1.3 0 0-0.1-0.1-0.1-0.1 0.7-6.8 1.4-13.6 2.1-20.3 0.4-3.8 3.3-4.3 6.7-4.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m304.5 42c2.5 0 4.5 0 7.4 0.1 1.2 1.1 1.6 2 1.7 2.9-3.2 0.3-5.9 0.6-8.9 0.9-0.8 0-1.2 0-1.9-0.2-2.5-0.1-4.7 0.1-6.9 0.2 2.2-2.3 4.3-5 8.6-3.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m84.1 102.1c0 0.2 0 0.4-0.1 0.9-2.7-7-8.1-14-1.4-22 0.4 0 0.5 0 0.5 0.5-0.3 4.7-2.9 8.9-0.1 13.5 1.1 1.9 0.8 4.7 1.1 7.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m330 436.4c2-0.2 3.8 0 5.8 0.4-2.8 4.4-5.8 8.5-9.3 13.2 1.2-4.8 2.2-9 3.5-13.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m60.8 140c-0.6-0.4-1.3-1.3-1.9-3 0.9-6.7 1.7-12.7 2.5-18.7 0.2-0.2 0.5-0.5 0.7-1 0.1-0.3 0.2-0.3 0.7-0.4-0.5 7.6-1.2 15.1-2 23.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m199.4 347c0.1-1.8 0.6-3.6 1.3-5.7 1.6 2.4 3.8 4.9 4.1 7.7 0.2 3.2-1.2 6.5-2.3 9.9-0.1-2.8 0.6-5.7 0.3-8.6-0.1-1.1-1.9-2.2-3.4-3.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m42 225c1.7 3.4 3.3 6.9 5 10.6-0.7 1.9-1.3 3.3-2 5.2-1-2.1-2-4.5-3-7.8 0-3.2 0-5.6 0-8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m295.5 46c2.6-0.2 4.8-0.4 7 0-6 1.1-11.6 2.6-16.3 6.8-1 0.9-2.8 0.9-4.2 1.2 0 0-0.1-0.1-0.1-0.1 3.2-4.7 8-6.6 13.6-7.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m268.9 69.9c2.5-3.6 4.9-7.1 7.7-10.8 0.4-0.1 0.5-0.1 0.5 0.3-1.3 2.5-2.5 4.6-3.9 7 1.9-0.6 3.3-1 4.6-1.1-1.6 2.2-3.1 4-4.7 5.6-1.4-0.5-2.7-0.7-4.1-0.9 0 0-0.1-0.1-0.1-0.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m42 224.6c0 2.8 0 5.2 0 8-0.3-3.8-1.1-8.2-0.9-12.5 0.3-4.9 1.4-9.8 2.5-15 0.7 3.4 1.5 7 1.2 10.6-0.2 2.9-1.8 5.7-2.8 8.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m410.7 457.7c0.6 3.3 0.9 6.4 1.3 10-4.7-1.8-2.9-6.6-3.8-10.1-1.1-4.1-0.2-8.7 0.4-13.1 0.6 4.3 1.1 8.7 2.1 13.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m248.1 136q1.8 0.2 3.7 0.5c-0.3 2.8-0.5 5.2-1 8.2-1.4 0.5-2.7 0.4-3.9 0.2 0-2.3 0.1-4.7 0.4-7.6 0.5-0.7 0.7-1 0.8-1.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m342.4 390c0.7-2.2 1.7-4.5 2.7-6.8q1.2 0.4 2.4 0.9c-1.9 5.2-3.8 10.3-6.1 15.7 0.7-3.3 1.6-6.8 2.5-10.2 0-0.1-0.3-0.2-0.4-0.2-0.3 0.1-0.5 0.3-1.1 0.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m362.1 433.4c0.7 0.5 1.2 1.5 1.9 2.4 1.1 1.1 2.2 2.1 3.7 3.2 0 1.1-0.1 2.3-0.8 3.1-0.6 0.8-1.9 1.9-2.5 1.7-0.9-0.3-2-1.6-2.2-2.5-0.3-2.5-0.2-5-0.1-7.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m342.1 440.2c0.4-1.6 0.8-3.7 1.9-5.2 0.4-0.4 2.8 0.3 4 1 1.3 0.7 2.3 2 3.7 3-0.9 1.2-2.2 2.4-4.3 4.2-0.3-3.2-0.5-5.1-0.7-8.2-1.9 2.2-3.1 3.6-4.6 5.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m381.1 442.4c3.3-0.4 6.5-0.3 9.8 0.1-3 1.7-6.1 3-9.7 4.5 0-1.4-0.1-2.8-0.1-4.6z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m199.1 409.4c1.1-0.4 2.2-0.4 3.6-0.4 0.2 2.9 0 5.8-0.3 8.6q-1 0.1-2 0.2c-0.5-2.6-0.9-5.3-1.3-8.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m341 44c0-1.1 0-2.2 0-3.7 3.1 0.3 6.2 1 9.6 1.8-2 1-4.4 2-7.3 2.7-1.2-0.4-1.8-0.6-2.3-0.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m358.4 215c-0.7-1.3-1-2.7-1.4-4.5 0.9-2.5 1.9-4.7 3.1-7.6 0.5 1.2 0.7 1.9 0.9 2.9-0.7 3.2-1.5 6.1-2.6 9.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m511.9 492.4c3.4 2.9 6.5 2.1 9.6-1.3-0.9 2-2.2 4.1-3.4 6.2-2.1-1.5-4.1-3-6.2-4.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m239 407.4c6.7 0 11.2 3.1 11.9 8.3-3.9-2.4-7.8-5.2-11.9-8.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m261.2 91c0.2-1.7 0.4-3.5 0.7-5.7 1.1-3.6 2.2-6.8 3.7-10.2 0.4-0.1 0.5 0 0.5 0.4-1.7 5.4-3.3 10.5-4.9 15.5z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m199.6 377.1c0.3 8.9 0.2 18.1-0.2 27.6-0.2-8.9-0.2-18.2 0.2-27.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m105.1 279.5c-1-0.9-3-2.4-2.8-3.5 0.4-2.7 2-5.3 3.4-7.9 0.1 3.6-0.3 7.3-0.6 11.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m405.9 264.6c-2.8-1.8-5.9-3.9-8.8-6.3 2.9 1.8 5.8 3.9 8.8 6.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m394 131c1.4-1.6 2.8-3.3 4.5-4.9-0.3 2-0.9 4-1.5 6.6 0 0.6-0.1 1-0.1 1-0.7 0-1.4 0-2.5-0.4-0.4-1-0.4-1.7-0.4-2.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m246.6 145.1c1.5 0 2.8 0.1 4.2 0 0.4 2.1 0.6 4.2 0.5 6.7-1.9-2.1-3.4-4.3-4.7-6.7z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m392.9 444.4c3.2-0.7 6.3-1 9.9-1.3-0.1 0.8-0.3 2.2-0.9 2.3-2.2 0.8-4.5 1.3-6.8 1.4-0.6 0.1-1.4-1.3-2.2-2.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m203.4 408.9q0.6-6.5 2.1-13.7-0.5 6.6-2.1 13.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m222.1 403.4c2.2 0.5 4.4 1.3 6.7 2.4-1.1 1.1-2.4 1.9-3.9 2.7-1.1-1.9-2-3.3-2.8-5.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m94 82.6c-0.4 0.3-0.9 0.4-2 0.2-2.5-1-4.2-1.9-6.1-3-0.5-0.5-0.7-0.7-1-0.9 4.6-3.1 6.3 1.4 9.1 3.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m52 250.4c4.4-0.5 4.8 2.6 5 6.3-1.6-1.7-3.2-3.9-5-6.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m251.1 154.4c0.9-0.1 1.6 0.1 2.7 0.9 0.2 1.3 0.2 2 0 2.8-0.5 0.4-0.7 0.6-0.8 1.4 0 2.1 0 3.8-0.2 5.5-0.2 0-0.6 0-0.6 0-0.4-3.4-0.8-6.8-1.1-10.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m417.9 276.6c-3.1 0.8-5.7 0.2-5.9-4.3 1.9 1.1 3.8 2.6 5.9 4.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m357.4 431.1c0.9-0.9 2.2-1.9 3.5-2.9 0.5 0.8 1 1.6 1.2 2.7-1.6 0.2-3 0.1-4.7 0.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m403.4 442.9c0-3.1 0.3-6.4 1.1-9.8 0 3.1-0.4 6.4-1.1 9.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m136.4 240c0.8-1.9 1.9-3.9 3.3-5.9-0.7 1.9-1.8 3.8-3.3 5.9z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m99 89.7q-2.1-2.2-4-5.5 2.1 2.2 4 5.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m410 430.4c0.4 3 0.7 6.4 1.1 10.3-0.4-3-0.8-6.4-1.1-10.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m45.9 243.4c1.3 1.1 2.7 2.5 4.1 4.3-1.4-1-2.7-2.5-4.1-4.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m220.1 394.4c0.8 1.8 1.5 4 2 6.5-0.8-1.9-1.5-4-2-6.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m265.9 74.9c0.8-1.6 1.6-3.2 2.7-4.9 0.3-0.1 0.4 0 0.4 0.4-1 1.8-1.9 3.2-2.9 4.7 0 0-0.1-0.1-0.2-0.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m338.1 438.4c1 0.4 1.9 1.2 3 2.2-0.1 1-0.5 1.8-1.2 3.1-0.8-2.1-1.4-3.5-1.8-5.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m252.1 165.2c0.1-0.2 0.5-0.2 0.9 0 0.3 1.4 0.2 2.6-0.3 3.8-0.2 0-0.7 0-0.7 0 0-0.8 0-1.6 0-2.7 0-0.4 0-0.9 0.1-1.1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m116.4 259.1c0.8-1 1.9-2 3.3-3-0.7 1-1.8 1.9-3.3 3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m380.1 433.4q0.5 3 0.9 7.3-0.5-3-0.9-7.3z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m50.1 174c0 0.5 0 0.9-0.1 1.7-0.2 0.3-0.4 0.3-0.9 0.3-0.1-2.3 0-4.5 0.4-6.9 0.4-0.2 0.5-0.1 0.5 0.3 0.1 1.8 0.1 3.2 0.1 4.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m335.6 38.9c-0.2 0.6-0.7 1.2-1.2 1.9-0.5-0.8-0.9-1.5-1.3-2.6 0.7 0 1.5 0.4 2.5 0.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m332.6 427c0 1.5-0.4 3.2-1.1 4.9 0-1.5 0.4-3.1 1.1-4.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m408.9 267.6c-0.8-0.4-1.9-1.2-2.9-2.3 1 0.4 1.9 1.2 2.9 2.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m220.1 380.4c0.2 1.1 0.4 2.6 0.3 4.3-0.3-1.1-0.3-2.5-0.3-4.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m330.1 32.6c-0.8 0.4-1.6 0.4-2.8 0.4 0.6-0.3 1.7-0.5 2.8-0.4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m339.9 36.6c-0.5 0.4-0.9 0.4-1.7 0.4 0-0.7 0.4-1.3 0.7-2 0.4 0.4 0.7 0.9 1 1.6z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m61.8 142.1c-0.3 0.7-0.8 1.3-1.7 1.9 0.1-0.5 0.4-1 0.8-1.7 0.2-0.3 0.4-0.4 0.9-0.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m378.3 183c-0.1-0.5 0-1 0.4-1.8 0.2 0.5 0.1 1.2-0.4 1.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m206.4 394c-0.2-0.7-0.1-1.6 0.2-2.7 0.2 0.7 0.1 1.6-0.2 2.7z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m220.7 367c0.1 0.4 0 1-0.3 1.8-0.2-0.4-0.1-1.1 0.3-1.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m396.9 257.7c-0.4 0.1-0.9 0-1.7-0.4 0.4-0.1 1 0 1.7 0.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m510.9 490.3q0.5 0.3 1 1.5-0.4-0.3-1-1.5z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m84.6 79c0.6 0.1 0.8 0.3 0.9 0.8-0.6 0.2-1 0.3-1.5 0.2 0 0-0.1-0.1-0.1-0.1 0-0.3 0.2-0.6 0.7-0.9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m85 105.3q0.3-0.2 0.9 0.4-0.3 0.2-0.9-0.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m253 417.3q0.2-0.1 0.8 0.6-0.2 0.1-0.8-0.6z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m251 416.3c0.2-0.2 0.5 0 0.9 0.4-0.2 0.1-0.5 0-0.9-0.4z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m84.1 104.2c0.3 0 0.5 0.2 0.8 0.7-0.2 0-0.6-0.2-0.8-0.7z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m331.9 33.7c-0.3 0.2-0.5 0-0.8-0.4 0.2-0.1 0.5 0 0.8 0.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m324.7 33.1c0.2 0.3 0 0.5-0.4 0.8-0.1-0.2 0-0.5 0.4-0.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m280.9 54.9c0.2-0.3 0.4-0.5 0.8-0.9q0.3-0.1 0.2 0.2c-0.3 0.5-0.6 0.7-0.9 0.8 0 0-0.1-0.1-0.1-0.1z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m279.9 55.9c0.2-0.3 0.4-0.5 0.8-0.9 0.2-0.1 0.3 0 0.2 0.2-0.3 0.5-0.5 0.7-0.9 0.8 0 0-0.1-0.1-0.1-0.1z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m411 270.7q-0.3 0.1-0.9-0.6 0.3 0 0.9 0.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m399.9 117.7c-0.3 0.1-0.5-0.1-0.8-0.6 0.2 0 0.5 0.2 0.8 0.6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m354.3 435q-0.1-0.2 0.6-0.8 0.1 0.2-0.6 0.8z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m399.3 123c-0.2-0.2 0-0.4 0.4-0.8 0 0.1-0.1 0.4-0.4 0.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m356.3 433c-0.2-0.2 0-0.5 0.4-0.9 0.1 0.2 0 0.5-0.4 0.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m247.8 136c0.2 0.3 0 0.6-0.4 0.9-0.2 0.1-0.4-0.4-0.4-0.6 0.1-0.3 0.3-0.3 0.8-0.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m352.3 439c-0.2-0.2 0-0.5 0.4-0.9 0.1 0.2 0 0.5-0.4 0.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m330.7 433c0.2 0.2 0 0.5-0.4 0.8 0-0.1 0-0.4 0.4-0.8z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m355.3 434q-0.1-0.3 0.6-0.8 0.1 0.3-0.6 0.8z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m397.1 133.8c-0.2-0.1-0.1-0.5-0.1-0.7 0.3 0 0.6 0.2 0.9 0.6-0.1 0.3-0.5 0.2-0.8 0.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m246.7 135c0.3 0.1 0.3 0.3 0.3 0.8-0.2 0-0.4-0.4-0.3-0.8z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m353.3 437c-0.2-0.2-0.1-0.5 0.4-0.8 0 0.1-0.1 0.4-0.4 0.8z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m332.9 36.7c-0.3 0.1-0.5-0.1-0.8-0.6 0.2 0 0.6 0.1 0.8 0.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m425 281.8q-0.3 0.2-0.8-0.5 0.3-0.3 0.8 0.5z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m122.3 254q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m121.3 255q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m120.3 256q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m115.3 260q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m114.3 261q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m113.3 262q-0.1-0.3 0.6-0.9 0 0.3-0.6 0.9z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m112.2 262.9c-0.1-0.3 0.1-0.6 0.7-0.8 0 0.2-0.2 0.5-0.7 0.8z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m110.3 264q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m109.3 265q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m108.3 266.1q-0.1-0.4 0.6-1 0.1 0.4-0.6 1z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m155.8 265.1c0.2 0 0.2 0.2 0.2 0.7-0.2-0.1-0.3-0.4-0.2-0.7z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m83 81c0.1-0.4 0.3-0.7 0.7-1q0.3-0.1 0.2 0.2c-0.3 0.5-0.5 0.7-0.8 0.8 0 0-0.1 0-0.1 0z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m123.3 253q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m107.3 267q-0.1-0.3 0.6-0.9 0.1 0.4-0.6 0.9z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m423 280.8q-0.3 0.2-0.9-0.5 0.4-0.3 0.9 0.5z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m105.9 280.8c0 0.3-0.4 0.5-0.6 0.5-0.3-0.2-0.3-0.5-0.3-1.1q0.5-0.1 0.9 0.6z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m95.1 83.7q-0.4 0.1-1-0.6 0.3-0.1 1 0.6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m421 279.7q-0.3 0.1-0.9-0.5 0.3-0.1 0.9 0.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m54.6 279.2q0.2 0.4-0.5 0.7-0.4-0.4 0.5-0.7z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m420 278.7q-0.3 0.1-0.8-0.5 0.2-0.1 0.8 0.5z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m419 277.7q-0.4 0.2-0.8-0.5 0.2-0.1 0.8 0.5z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m106.3 268q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m409.9 268.8c-0.3 0.1-0.5-0.1-0.8-0.6 0.2-0.1 0.5 0.1 0.8 0.6z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m411.9 271.7q-0.2 0.1-0.8-0.5 0.3-0.1 0.8 0.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m130.3 246q-0.1-0.3 0.6-0.9 0.1 0.4-0.6 0.9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m262.8 225.2c0.2 0.2 0.1 0.5-0.2 1-0.2-0.2-0.1-0.6 0.2-1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m99.9 91.8c-0.2 0-0.5-0.2-0.8-0.8 0.2 0 0.6 0.2 0.8 0.8z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m234.8 233c-0.1 0.1-0.3 0.2-0.7 0.2 0.1-0.2 0.2-0.2 0.7-0.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m135.2 240.9c-0.1-0.3 0.2-0.6 0.7-0.8 0 0.3-0.2 0.6-0.7 0.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m45.1 242.2c0.3-0.1 0.6 0.1 0.8 0.7-0.2 0-0.5-0.2-0.8-0.7z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m133.3 243c-0.2-0.2-0.1-0.5 0.4-0.9 0.1 0.2 0 0.5-0.4 0.9z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m132.3 244q-0.1-0.3 0.6-0.9 0.1 0.4-0.6 0.9z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m131.3 245q-0.1-0.3 0.6-0.9 0.1 0.4-0.6 0.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m277.9 57.9c0.2-0.3 0.4-0.6 0.8-0.9 0.3 0 0.3 0 0.2 0.2-0.3 0.5-0.5 0.7-0.9 0.8 0 0-0.1-0.1-0.1-0.1z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m278.9 56.9c0.2-0.3 0.4-0.5 0.8-0.9 0.2-0.1 0.3 0 0.2 0.2-0.3 0.5-0.5 0.7-0.9 0.8 0 0 0 0-0.1-0.1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m129.3 247q-0.1-0.3 0.6-0.9 0.1 0.4-0.6 0.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m128.3 248q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m50 248.3q0.3-0.1 0.9 0.6-0.3 0.1-0.9-0.6z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m127.3 249q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m51 249.3q0.3-0.1 0.9 0.6-0.3 0.1-0.9-0.6z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m221.1 360.3c0.4-0.1 0.5 0.2 0.2 0.6-0.2-0.1-0.2-0.2-0.2-0.6z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m220.1 358.3c0.3-0.1 0.5 0.1 0.8 0.6-0.2 0-0.5-0.2-0.8-0.6z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m126.3 250q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m276.9 58.9c0.2-0.3 0.4-0.6 0.8-0.9 0.2-0.1 0.3 0 0.2 0.2-0.3 0.5-0.5 0.7-0.8 0.8 0 0-0.1 0-0.2-0.1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m125.3 251q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m124.3 252q-0.1-0.3 0.6-0.9 0.1 0.3-0.6 0.9z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m355.6 238.1c0.7 1.6 1.1 3.4 1.4 5.5-2.8 9.5-2.4 19.5-9.7 27.3-4.1 4.4-7.2 10.4-9.4 16.2-2.4 6.1-3.3 12.9-4.7 19.9-3.2 8.3-6.4 16.2-9.7 24.1-0.6 1.5-1.8 2.7-3.1 4.1 1.1-6 2.4-12.1 4.1-18 0.7-2.7 1.2-5-2.4-5.7-17.1-3.4-26.9-15.1-32.7-30.4-4.5-11.8-8.1-24.1-11.8-36.3-0.8-2.3-0.4-4.9-0.2-7.7 2.4 0.8 4.6 1.8 6.7 2.8 11.8 9.7 25.1 16.2 39.8 19.5 10.8 2.5 22.5-4 27-14.2 1.1-2.5 2.9-4.7 4.7-7.1z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m411.1 410.6c-0.1 0.4-0.6 0.4-0.8-0.1-0.6-4.7-0.9-9-1.2-13.3 0-1.5-0.1-3 0.2-5.2 0.8-6.1 1.2-11.6 1.7-17 2.9 11.7 1.5 23.5 0.1 35.6z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m411 374.6c-0.5 5.8-0.9 11.3-1.7 17-0.8-4.8-1.3-9.9-1.6-15.3 0.8-2.2 1.4-4.1 2.3-6.8 0.4 2 0.7 3.4 1 5.1z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m409.1 397.6q0.4 5.8 0.9 12.9c-0.4 1.4-0.8 2.4-1.6 3.4 0-5.2 0.3-10.5 0.7-16.3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m406.7 368.2q0.5 0.6 0.5 1.6-0.5-0.5-0.5-1.6z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s49",
    d: "m103.6 308.3c1.9 0.8 4.4 1.6 5.2 3.3 2.7 5.4 4.8 11 7.2 17.4 0 2.8 0 4.9 0 7.4 0.3 2.4 0.6 4.4 0.6 6.6-1.8 7.8-3.3 15.4-5.2 23-2 3.1-3.7 6.1-5.6 9.4-1.7 3.7-3.3 7.1-4.8 10.6 0 0 0-0.1-0.4-0.2-0.7 0.6-1.2 1.4-1.6 2.2 0 0 0-0.1-0.3 0.1-0.4 0.7-0.6 1.3-0.7 1.9 0 0 0-0.1-0.2 0-0.5 0.4-0.7 0.7-1.2 1.2-2.3 7.3-4.7 14.2-6.3 21.4-0.5 2.2 1 4.9 1.5 7.8 0 1.5-0.1 2.7-0.4 4.1-0.2 0.7-0.2 1.1-0.3 1.9 0.4 3.5 0.9 6.5 1.2 9.9 0.2 1.8 0.5 3.3 0.7 5.1 0.1 9.2-1.9 16.9-11.4 20.6-4.8 0.1-9.2 0.3-13.8 0.2-0.5-0.3-0.9-0.4-1.4-0.7-1.9-1.2-3.5-2.2-5.5-3.3-1.4-0.9-2.7-1.5-4.1-2.5-1.3-1.1-2.5-2-3.8-3.1-0.6-0.7-1.1-1.2-1.7-2-0.8-1.1-1.6-1.9-2.3-2.6 0 0 0 0 0-0.3-0.7-1.1-1.3-1.9-2-3.1-1.7-3.8-3.3-7.2-4.9-10.8-0.1-0.5-0.2-0.6-0.1-1.2-0.5-3.4-1-6.5-1.5-10 0.1-6.5 0-12.6 0-19.1-0.2-2.1-0.5-3.8-0.7-5.8 0.2-1.2 0.2-1.9 0.5-2.9 0.8-3.7 1.1-7 1.7-10.4 0.5-3.4 1.3-6.9 1.9-10.4 2.3 12.1 3.9 24.3 7 36 2.5 9.4 8.8 11 16.1 4.5 6.1-5.5 11.6-11.8 16.6-18.4 5.7-7.6 10.9-15.6 15.7-23.7 5.6-9.7 5.9-20.7 5.7-31.5-0.1-5-0.7-10-0.8-15.7-0.1-2.9-0.5-5.1-0.9-7.3 0.1-3.1 0.1-6.2 0.3-9.6z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s50",
    d: "m112.2 147.4c0.4 0.1 0.8 0.2 1.5 0.8 0.6 1.6 0.9 2.7 1.2 4-0.1 0.2-0.2 0.6-0.5 0.7 0.3 1.4 1 2.8 1.6 4.1 0 0 0 0 0 0.4 0.6 1.4 1.3 2.5 2.1 3.9 1.8 1.4 3.3 2.6 4.9 3.7 0 0 0 0 0 0 0.2 0.9 0.1 2 0.6 2.8 3.9 6.9 3.7 7.6-3.8 10.4-0.2 0.4-0.3 0.8-0.5 0.5-0.3-0.3-0.4-0.5-0.4-1-0.5-0.8-1.1-1.3-2-2-1-0.8-1.7-1.5-2.6-2.5-4-5.4-9-9.9-8.4-17.5 0.2-1.3 0.3-2.3 0.7-3.4 1.1-1.3 1.8-2.3 2.9-3.4 1.1-0.5 1.9-1 2.7-1.5z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m44 373.6c-0.7 3.9-1.5 7.4-2 10.8-0.6 3.4-0.9 6.7-1.9 10.2-0.7-0.5-0.9-1.1-1-2 0-2.8-0.1-5.2 0-8 0-1.5 0-2.5 0-4 0.1-3.2 0.1-5.9 0.2-8.9 0.3-5.2 0.3-9.9 0.5-15.2 0.2-2.4 0.2-4.4 0.5-6.7 0.2-1.5 0.3-2.7 0.5-4.2 0.1-1.1 0.2-1.8 0.4-2.9 0.3-1.8 0.5-3.3 0.7-5 0.2-0.8 0.2-1.2 0.4-2 0.8-3.4 1.5-6.6 2.1-9.8 0.3 0 0.6 0 1.2 0.1-0.3 15.7-0.9 31.5-1.6 47.6z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m129.7 183.8c1.7 2.2 5.1 4.7 4.7 6.4-0.5 2.6-3.7 4.6-6.4 6.6-1.7-1.6-2.9-3.2-4.1-4.9-0.1-0.2-0.2-0.7-0.2-1-0.5-1.5-1.2-2.7-1.9-4.2-0.3-1.1-0.5-1.8-0.1-2.6 3-0.2 5.5-0.2 8-0.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m114.7 152.8c0 0 0.1-0.4 0.5-0.5 2.6 2.1 4.8 4.4 6.9 6.7 0 0-0.1 0 0 0.2 0.3 0.4 0.6 0.6 0.9 0.7 0.2 1.6 0.4 3.3 0.3 5-0.3 0.1-0.3 0.1-0.3-0.2-1.3-1.8-2.7-3.3-4.1-5-1.1-1.1-2-1.9-2.9-2.7 0 0 0 0 0-0.4-0.5-1.5-0.9-2.6-1.3-3.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m129.7 183.5c-2.5 0.4-5 0.4-8.3 0.4-1.1-1.7-1.5-3.3-1.9-4.9 0 0 0.1-0.4 0.2-0.4 3.4 1.4 6.7 3 10 4.9z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m124 192.1c1.1 1.5 2.3 3.1 3.6 4.8 0.6 1 0.9 1.8 1.2 3-1.3 0.2-2.7 0.1-4.5-0.4-0.4-2.8-0.3-5.1-0.3-7.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m81.3 241.9c0.9-3.4 2.9-5.9 7.3-5.9q-3.1 3-7.3 5.9z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m62.3 243.3c3-0.5 6.3-0.7 9.7-0.6-3 3.8-6.3 1-9.7 0.6z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m74.4 244c0.9-3.2 3.3-2.8 6.2-2-0.6 4-3.4 2.4-6.2 2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m103.2 318.3c0.5 1.8 0.9 4 1 6.5-0.5-1.9-0.8-4-1-6.5z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m54 242.4c0.8-0.2 1.7 0 2.8 0.3-0.8 0.2-1.7 0.1-2.8-0.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m123 159.6c-0.3 0.2-0.6 0-0.9-0.5 0-0.4 0.2-0.5 0.5-0.6 0.3 0.3 0.3 0.5 0.4 1.1z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s54",
    d: "m256.2 342.7c-7.5-30.1-7.7-60.4 3.6-90 3.3-8.8 7.6-17.2 11.9-25.6 0.4 0.2 0.6 0.6 0.6 0.6-1.1 3.8-2.5 7.6-3.4 11.5-3.5 14.8-8.1 29.5-9.9 44.6-2.1 17.5-1.6 35.4-2.3 53.1-0.1 1.9-0.2 3.7-0.5 5.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m260.3 374.8c-1.6-8.5-2.8-17.1-4-26.3 1.3 2.9 3.1 6.1 3.6 9.4 0.7 5.5 0.5 11.1 0.4 16.9z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m284.4 239.9c-2.4-1-4.6-2-7-3.2-1.3-2.8-2.3-5.4-3.3-8.6 0.7-1.2 1.3-1.7 2-2.1q4.5 6.5 9 13.1c0.1 0.1 0 0.4-0.1 0.5 0 0.1-0.2 0.2-0.6 0.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m276.1 225.6c-0.7 0.8-1.3 1.3-2.1 2.1-0.4 0.2-0.7 0.1-1.4 0-0.3 0-0.5-0.4-0.6-0.6 0.3-5.4-3.1-3-5.7-3-0.1-0.6 0.1-1.2 0.7-2.1 1.7-1.3 2.8-2.2 4-3.1 1.2 0.6 2.4 1.1 4 2.1 0.9 0.6 1.5 0.8 2 0.9 0 0 0.1 0.5 0.1 0.7-0.3 1-0.7 1.8-1 3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m116 336c0-2.1 0-4.2 0-6.6 1.6-1.9 3.4-3.3 4.8-5 3.2-3.9 6-8.9 12-8.2 2.2 0.3 5.6 2.4 5.8 4.1 1.2 7.8 2.8 15.9 2 23.7-2.6 22.9-6.2 45.8-9.7 68.7-1.5 9.2-3.7 18.4-5.9 27.5-2.1 8.7-4.1 17.4-7.2 25.7-2.7 7.3-5.4 15.4-16.5 16.7-1.4-3.8-3.1-8.2-4.9-13.3 0-1.6 0.1-2.5 0.4-3.7 0.9-5.7 1.7-11.1 2.6-16.8 0.2-0.7 0.2-1.3 0.4-2.1 0.2-0.8 0.2-1.3 0.4-2 0.8-4.2 1.5-8 2.3-12.1 0.1-1.5 0-2.5 0.1-4 0.1-2.1 0-3.9 0.1-5.9 0.1-0.8 0-1.2 0.1-2.1 2.2-7 3.9-13.7 6.2-20.3 2.5-7.1 5.4-14.2 8.4-21.4 1.9-3.8 3.8-7.4 4.8-11.3 2.3-9.6 3.6-19.3-1.8-28.5-0.8-1.4-2.9-2-4.4-3.1z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s58",
    d: "m100 445c0 0.4 0 0.9-0.5 1.7-0.3 1.1-0.3 1.7-0.3 2.4-0.7 5.4-1.5 10.8-2.7 16.6-2.8 5.3-5 10-7.3 14.8 0 0 0 0.3-0.5 0.4-2.1 0.9-4 1.4-5.3 2.5-5.6 5.1-12.7 6.9-19.7 8.6-6.1 1.5-12.3 2.2-18.2-0.9-1-0.5-2.4 0-3.6 0-0.3 0.1-0.6 0-0.9-0.9-0.8-2.2-1.1-4.5-2.3-5.4-5.8-4.6-5.3-11.4-6.8-17.5-0.6-2.5-1.8-4.9-2.7-7.3-0.4-2.4-0.7-4.8-0.8-7.9 0.4-3.2 0.6-5.7 0.6-8.2 0-12.6 0-25.2-0.1-37.8-0.1-0.7-1.1-1.4-1.6-2.1 0-0.8 0-1.5 0.4-2.7 0.4-2.4 0.4-4.4 0.5-6.3 0-0.7 0-1.5 0.4-2.7 0.4-1.4 0.4-2.4 0.4-3.3 0-0.8 0-1.5 0.5-2.7 3.9-2.3 1.5-4.3 0.6-6.3 0-0.4 0-0.9 0.5-1.8 0.8-4 1.1-7.6 1.5-11.2 0-0.7 0-1.5 0.5-2.7 0.4-1.4 0.4-2.3 0.4-3.3 0.1-1.1 0.1-2.1 0.7-3.6 3.7-2.8 1.9-5.6 1.3-8.4 0-0.4 0-0.9 0.4-1.7 2.2-1.7 3.9-3 5.6-4.3 0 0.8-0.1 1.5-0.5 2.7-0.5 1.8-0.4 3.1-0.4 4.3-0.1 2.1-0.1 4.1-0.7 6.6-1 0.7-2 1.1-2 1.3 0.5 4.8 1.2 9.5 1.8 14.2 0 2.6 0 5.3-0.4 8.5-2.4 2.2-2.4 3.5 0.2 4.4 0 2.4 0.1 4.8-0.2 7.6-2.9 3-1.8 4.4 0.9 5.4 0.3 1.7 0.6 3.4 0.4 5.6-0.7 5.7-1 10.9-1 16.1 0 1.1 0.9 2.2 1.3 3.3 0.6 3.1 1.1 6.2 1.4 9.8-0.1 0.7 0.1 1 0.3 1.2 1.6 3.4 3.2 6.8 4.6 10.8-0.5 1.1-0.8 1.8-1.2 2.4q1.8 0.4 3.5 0.8c0 0 0 0 0 0.4 0.8 1.1 1.6 1.8 2.3 2.5 0.6 0.5 1.1 1 1.7 2.1 1.4 1.4 2.7 2.2 4 3 1.2 0.7 2.5 1.3 3.9 2.6 2.1 1.5 3.9 2.3 5.7 3.2 0.3 0 0.7 0.1 1.3 0.7 4.4 3.9 11.9 3.3 14.1-0.5 9.1-3.7 11.1-11.4 11.3-20.6-0.1-2.2-0.5-3.8-0.9-5.4-0.4-3.1-0.9-6.1-1.1-9.8 0.3-1.1 0.3-1.5 0.3-1.9 0.1-1.2 0.2-2.4 0.4-4.1 0.5-1.1 0.8-1.7 1.4-2.2 2.1-3.5 4-6.9 5.5-10.4 1.3-2.8 2.8-4.1 6.4-3-1.4 2.9-3.2 5.1-3.5 7.5-0.3 2.9 0.5 5.9 0.9 8.9 0 0.5 0.1 0.9-0.3 1.8-0.3 2.4-0.1 4.3 0.1 6.2 0 1.1 0.1 2.1-0.3 3.6-3.1 4.1-3.9 8.1-2.2 12.4zm-3.4 4.8q-0.7 0.2-1.4 0.4 0.3 0.5 0.5 1c0.3-0.3 0.6-0.6 0.9-1.4zm-3.2 2.7c0 0 0.1 0 0 0z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m42.1 491.4c1-0.3 2.4-0.8 3.4-0.3 5.9 3.1 12.1 2.4 18.2 0.9 7-1.7 14.1-3.5 19.7-8.6 1.3-1.1 3.2-1.6 5.1-2.4-4.1 6.6-11 9.3-18.1 11.5-7.8 2.3-15.8 3.3-23.9 1.4-1.5-0.4-2.8-1.4-4.4-2.5z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m29.1 460.4c1 2 2.2 4.4 2.8 6.9 1.5 6.1 1 12.9 6.8 17.5 1.2 0.9 1.5 3.2 2.1 5.2 0 0.4-0.4 0.4-0.9 0.2-2.9-3.9-5.4-7.6-7.8-11.2-0.7-2.4-1.4-4.8-2-8-0.3-1.8-0.7-2.9-1.1-4 0-0.8 0.1-1.5 0-2.6 0-1.5 0-2.5 0.1-4z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m31.8 479.2c2.7 3.4 5.2 7.1 7.9 11-3.6 3.5-4.8-1.4-5.9-2.7-1.7-1.9-1.6-5.3-2-8.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m89.5 480.3c2-4.6 4.2-9.3 6.8-14.2 0.2 0.7 0.1 1.6-0.1 2.8-2.1 4-4.3 7.6-6.7 11.4z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m28.8 467.2c0.6 0.9 1 2 1.2 3.4-0.6-0.8-1-2-1.2-3.4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m201.6 337.6c0-0.7 0.1-1.5 0.6-2.5 0.1 0.7-0.1 1.5-0.6 2.5z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m192 353q-6.2 19.1-12.4 38.3-0.7-0.2-1.4-0.3c1.1-6.3 2.2-12.7 3.4-19.5 2.7-6.2 5.3-12.1 8.6-18.2 0.9-0.3 1.4-0.3 1.8-0.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m192.2 352.7c-0.6 0.3-1.1 0.3-1.9 0.3q3.2-8.4 7.3-16.8c-1.5 5.3-3.3 10.8-5.4 16.5z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m175.6 381c-0.8 2.5-2 5-3.2 7.5q-0.7-0.2-1.4-0.4c0-2.4 0-4.8 0-7.7 1.5-0.1 2.9 0.3 4.6 0.6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m178.6 375.1q-0.6 2.3-2.2 4.8 0.6-2.3 2.2-4.8z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m173.3 371c-0.1-0.6 0-1.1 0.4-1.8 0.1 0.4 0 1.1-0.4 1.8z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s61",
    d: "m345 62.1c0.2 0.2 0.5 0.4 1.2 0.7 1.6 0.7 2.6 1.1 3.7 1.4 14.7 8 18.9 23.4 25.9 36.7 1.8 3.5 3.4 7.2 4.4 11 1.9 6.4-0.3 11.2-5.3 15.3-2.8 2.3-5.1 5.2-7.1 8.2-2.6 3.7-5 7.6-6.9 11.8-1.7 3.7-2.4 7.8-3.7 11.7-0.6 1.9-1.6 3.8-2.7 5.5-0.6-4.7-3.2-5.8-7.1-4.7-3.8 1.1-6.8 1-8.3-3.5-0.4-1.2-2.4-1.8-3.9-2.9-2.7-3.6-5.1-7-7-10.4 4.8 0.5 9.3 0.9 13.7 1.5 6 0.8 12 1.7 14.3-6.1 0.1-0.3 0.5-0.4 1.1-0.6 5-2.9 5.9-7.3 4.8-12.2-0.4-1.5-2.1-3.5-3.6-3.9-1.1-0.2-3.2 1.4-4.1 2.7-1.5 2.4-2.3 5.1-3.8 7.9-5.8 6.6-7.8 7.1-13.1 3-0.8-1.4-1.3-2.8-2.3-3.3-3.2-1.6-6.5-3-9.8-4.5q-0.2-0.9-0.4-1.8c1-0.6 2-1.2 3.4-1.7 1.7 0.4 3 0.9 4.4 1.3q4.9 1.7 9.7 3.3 0.3-0.6 0.5-1.2c-0.6-0.5-1.2-1-1.9-1.9-1.7-1.5-3.1-2.8-4.8-3.7-2.4-1.2-4.9-2.1-6.9-3.3 1.5-0.4 2.6-0.6 4-0.8 1.4-0.1 2.5-0.2 3.9-0.2 3.5 0.8 6.7 1.5 10 2 0.9 0.1 2-0.3 3-0.5-0.4-0.9-0.5-2.4-1.2-2.8-2.4-1.5-5-2.6-7.5-3.7-1.9-0.8-3.8-1.3-5.7-2q0.1-0.9 0.2-1.8c3-0.2 5.9-0.3 9.1-0.3 0.7 0.5 1.2 0.7 1.9 1.2 1.9 1.3 3.5 2.5 5.4 3 1.1 0.3 3.4-0.1 3.8-0.9 0.6-1.2 0.4-3.2-0.2-4.5-0.4-1-2-1.5-3.2-2.5-0.4-0.3-0.8-0.4-1.1-0.9-0.9-1.9-1.8-3.4-2.9-5.2-2.6-2.2-1-3.6 0.4-5.1 5.9-6.7 5-10.3-1.4-16.8-4.4-4.5-7.3-10.5-10.8-15.8-0.1-0.1 0.6-0.7 1.3-0.8 2.4 0.8 4.5 1.4 6.6 2.1z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s62",
    d: "m253 169c0.2-1.2 0.3-2.4 0.2-3.8-0.2-1.9-0.2-3.6 0.1-5.9 0.4-0.7 0.6-1 0.7-1.3 0-0.7 0-1.4 0-2.6 0.3-1.4 0.6-2.6 1.2-4.3 0.1-2.1 0-3.6-0.2-5.1 0-1.4 0-2.8 0.3-4.8 1.1-1.1 1.9-1.7 2.7-1.8 0.6 4.8 1.2 9.1 2 14.2 4.3-4.8 7.8-8.4 10.9-12.3 0.7-0.8 0-3.9-0.3-3.9-5.1-0.4-6.6-4.2-8.2-8.2-0.6-1.3-2.2-2.1-3.7-3.4-0.7-1.4-1.2-2.6-1.7-3.8 0-0.4 0-0.9 0.4-1.8 1.4-8.8 2.4-17.1 3.4-25.5 0.1-1 0.1-2 0.3-3.3 1.7-5.4 3.3-10.5 5-15.9 1-1.9 1.9-3.3 3-5.1 1.3-0.2 2.6 0 4 0.9-0.4 3.7-0.8 6.7-1.4 9.9 1.9 1.5 4.1 2.8 6.5 4.1 0.8 0.3 1.3 0.5 2.1 0.9 1.4 2.7 2.5 5.3 3.6 8.2 2.5 3.5 4 3.1 7.5-1.4 0.7 0 1.1 0 1.9 0.1 3.5 3.6 1.1 6.8-0.3 10.3-3.3 1.5-6.6 2.8-9.9 3.6-3 0.6-5 1.1-2.7 4.7 0.5 0.7-0.2 2.2-0.7 3-2.4-0.4-4.5-0.7-6.6-0.7-5.6 0.1-6.5 1.4-5.3 7.2 0.1 1.1 0.6 2.7 0.9 2.7 6.2-0.6 12.3-1.4 18.5-1.7 0.7 1.9 1.3 3.5 1.9 5.4-1.8 3-3.1 7.1-5.5 8-3.9 1.3-6 3.7-7.8 6.9-0.9 1.6-1.8 3.2-2.7 4.7-1.9 3.2-4 6.2-5.7 9.4-0.5 0.9 0.3 2.4 0.6 3.6 1.1-0.3 2.7-0.3 3.3-1.1 2.7-3.3 5.1-6.8 8.4-10 1.3 0.4 1.8 0.5 2.3 0.9-0.6 0.6-1 1-1.6 1.7-0.3 0.7-0.3 1-0.6 1.5-0.8 1.1-1.3 1.9-2.1 2.9-2.5 3.4-4.6 6.7-6.7 9.9 0 0 0.1 0-0.3-0.1-0.8 0.5-1.2 1-1.7 1.9-0.9 2.4-1.9 4.3-3.2 6.3-1.4 1.4-3.3 2.7-3.5 4.2-0.6 3.8-2.6 3.6-5.3 2.7 0 0 0-0.5 0-1-0.7-1.4-1.3-2.2-1.9-3.4-0.1-0.7-0.1-1.1-0.1-1.9-0.7-1.1-1.3-1.9-2-3.1 0-1.1 0-1.8 0-2.6z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m335.5 153.5c1.2 0.9 3.2 1.5 3.6 2.7 1.5 4.5 4.5 4.6 8.3 3.5 3.9-1.1 6.5 0 6.8 4.8 1 8.6-1 12.1-8.8 15.9-1.6 0.8-3 1.8-5.3 2.6-1.5 0.3-2.3 0.6-3 0.9-0.8 0-1.6 0.1-2.9-0.2-1.1-1.1-1.6-1.9-1.9-2.9 3.1-3 0.7-5.1-1-6.9-2.4-2.5-5.7-4.2-7.6-6.9-2.7-3.7-5.7-6-10.1-6.6 0.3-1.4 0.4-2.3 0.8-3.6 0.4-1.5 0.6-2.8 0.9-5.6-3.5 4.6-5.8 5.4-8 0.8-0.7-1.4-2.8-2-4.3-2.9-2.3-1.4-4.7-2.7-7-4.4 0.7-2.2 1.3-3.9 2.2-5.7 0.3 0 0.8-0.1 1.1 0 4.1 0.9 5.1 6.9 10.3 5.7-0.3-6.2-6-5.1-8.7-8.1-2-2.4 1.2-7-3.7-8-0.1-2.2-0.1-3.9 0.2-5.7 0.7-0.7 1.1-1.3 1.6-1.9 0 0 0 0 0.3 0 4-0.7 7.5-1.4 11.3-2 2.1 3 3.9 5.8 5.3 8 1.2-1.6 2.4-4.6 4.5-5.5 2.1-0.9 5.1 0.2 7.6 0.8 0 0.7 0 1.1 0 1.6q-1.5 0.8-3 1.7 0.2 0.9 0.4 1.8c3.3 1.5 6.6 2.9 9.8 4.5 1 0.5 1.5 1.9 1.9 3.5-4 4-8.1 2.3-12.4 1.6-1.4-0.8-2.5-1.4-3.7-2.3-0.7-0.8-1.4-1.2-2.3-1.7-0.8 0-1.3 0-2 0-0.1 0.8 0 1.5 0.2 2.5 0 0.7 0 1.1-0.2 1.7 0.2 1.1 0.7 2.1 1.2 3.4 0.4 2.4 0.8 4.4 1.2 6.7 0.6 1.1 1.3 1.9 2.1 2.9 0.8 1 1.3 1.9 1.9 3.1 1.3 1.5 2.6 2.6 4.2 3.7 0.7 0.1 1.2 0.1 1.7 0.4 0.7 0.1 1.4-0.1 2.5-0.3 0.7 0 1.1 0 1.9-0.1 0.7-0.7 1.1-1.4 1.7-2.4 0.2-0.6 0.3-0.9 0.4-1.1z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m263.4 213.1c-0.6-0.9-1.3-1.9-1-2.3 3.3-4.5 2.1-8.4-1.4-12.5 2 0.1 5-0.1 5.9 1.1 3.5 4.8 8.5 3 11 1.1 5.4-4.1 10.5-6.5 18-3.8 1.3 2.7 0.8 9.7 8.9 6.7-2.6 8.8-10.4 12.4-18.3 9.1-1.4-0.6-3.8-0.8-4.7 0-6 4.8-12 1.7-18.4 0.6z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m314.2 157.1c-0.2 1-0.3 1.9-0.8 3.4-1.5 1.3-2.6 2.1-2.7 2.1 4 2.5 8.4 4.6 11.9 7.7 3.4 3 5.9 7 8.7 11.1 0 1.2-0.1 2.1-0.2 2.9-0.5 0-1 0-1.9-0.4-2.9-3.8-4.7-8.1-10.5-7.9-5.1-1.3-9.9-2.6-14.9-4.2-2.2-0.1-4.2 0-6.3-0.1-0.2-0.4-0.3-0.6-0.4-1.2-1-1.4-2-2.5-3.3-3.8-0.8-2.8-1.4-5.2-1.6-7.7 4-4.7 8.4-5.6 13.9-3.5 2.5 1 5.4 1.1 8.1 1.6z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m372.7 168.5c-0.4-1.5-0.6-2.8-1.1-4-1.5-4.1 1.3-10.2 5.6-11 1-0.2 3.2 1.3 3.4 2.2 0.8 4.4 2.6 3.9 5.3 1.7 1.1-1 2.6-1.5 4-2.2 0.2 1.6 0.6 3.2 0.8 4.9 0 0.8-0.3 1.7-0.7 2.4-1.3 2.1-2.7 4.2-4.1 6.3q-2.4-2.2-4.8-4.4c-0.3-0.3-0.7-0.6-0.5-0.5-2.1 1.9-4.1 3.6-6.4 5.5-0.7-0.1-1-0.4-1.5-0.9z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m295 190c-0.7 0-1.5 0-2.6-0.3-0.7-0.8-1.1-1.3-1.4-2.2 0-2 0-3.7 0.5-5.3 7.1 1.1 13.8 2.3 20.6 3.2 0.9 0.1 1.9-1.6 3.3-2.4 1.2 0 2 0 3.1 0 1.5 0.7 2.7 1.3 3.9 2-2.2 2-4.5 3.9-7.3 5.7-5.4 0.6-10.3 1.5-15.1 2.3 0 0 0 0 0-0.4-0.2-4.6-2.3-4.2-5-2.6z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m386.6 98c1.3 2.8 2.7 5.4 3.2 8.3 0.9 5.1 1.9 10.3 1.7 15.5-0.1 3.2-2.2 6.3-3.9 9.8-1.5 0.4-2.5 0.5-3.6 0.5 0.4-1.6 1.1-3.1 1.2-4.7 0.3-4 0.8-8.1 0.4-12-0.7-6.2-1.9-12.3-3-18.8 1.2 0.4 2.4 0.9 4 1.4z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m340.6 44c0.9 0.2 1.5 0.4 2.2 0.8-2.7 2-5.5 4.2-8.7 5.3-1.9 0.6-4.5-0.8-6.8-1.1-1.6-0.3-3.3-0.3-5.5-0.2-2.9-1.1-5.4-2.5-7.8-3.8-0.5-0.9-0.9-1.8-1.7-2.9-0.2-1.2-0.1-2.3 0-3.3 8.7 5.9 17.9 7.3 28.3 5.2z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m322.6 185.2c-1.4-0.9-2.6-1.5-4.3-2.5-1.4-0.5-2.3-0.7-3.4-1.2-5.5-2.3-10.7-4.3-15.8-6.7 1.8-1.1 3.4-2 5-2.8 4.7 1.4 9.5 2.7 14.6 4.4 2.4 3.1 4.4 5.9 6.5 8.6-0.8 0.1-1.5 0.3-2.6 0.2z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m279 192c-7.1 3.4-11 2.6-15.9-4.1-0.1-1.4-0.1-2.2 0.3-2.9 2.8-1 5.2-2 7.6-2.5 0 2.1-0.2 3.7 0.1 5.3 0.2 1.4 1.1 2.6 1.7 3.8 1.2-0.8 3-1.4 3.5-2.5 2.3-5.2 7.3-3.6 11.2-4.7 0.2-0.1 0.9 1.6 1 2.5-4.5-0.2-7.4 1.8-9.5 5.1z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m313.6 45c2.8 1.3 5.3 2.7 8.1 4.1 2.5 3.7 6 4.6 10 5 5.3 0.5 10.3 2.2 13.3 7.6-2.1-0.3-4.2-0.9-6.7-2.1-1.4-1.2-2.4-2.3-3.5-2.5-5.9-1-11.3-2.7-16.1-6.7-2-1.7-5-2.4-7.6-3.3-2-0.7-4.1-0.8-6.1-1.2 2.7-0.3 5.4-0.6 8.6-0.9z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m317 215.2c-3 1.2-5.6 2.5-9.4 4.4 3.8-7.2 7-8 15.2-6.3q4.6-1 9.3-2.1c-2.5 5.7-7.5 6.5-15.1 4z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m363.5 185.8c-2.6 4.6-5.2 8.9-8.2 13.8-4.5-4.6 1.8-5.1 1.7-7.8 0-2.7 1.3-5.4 2.3-9.3 1.5 1 2.9 2 4.2 3.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m263.1 185c-0.1 0.7-0.1 1.5-0.2 2.6-4.6 0.8-3.9-3.8-5.8-6.3 2.6 0.6 4.6 0.8 5.2-3 0.2-1.5 2.1-2.8 3.5-3.8-0.7 3.7-1.7 7.1-2.7 10.5z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m279.2 192.3c1.9-3.6 4.8-5.6 9.5-5.1 1.2 0.4 1.7 0.6 2.3 0.8 0.3 0.4 0.7 0.9 1 1.7-4.1 1.1-8.3 2-12.8 2.6z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m300 193.4c4.8-1.2 9.7-2.1 14.8-2.7-2 1.9-4 3.7-6.3 5.2-3.5 2.3-6 0.2-8.5-2.5z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m325.5 185c-2.4-2.7-4.4-5.5-6.4-8.6 5.4-0.6 7.2 3.7 9.7 7.5-0.9 0.6-1.9 0.8-3.3 1.1z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m384 132.5c1.1-0.4 2.1-0.5 3.5-0.5 2.2-0.3 3.9-0.7 6.1-1 0.4 0.6 0.4 1.3 0.5 2.2-3.4 1.4-6.9 2.6-10.8 3.6 0-1.3 0.4-2.7 0.7-4.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m286.7 222c-0.5 1.4-1.4 2.8-2.4 4-0.2 0.1-1.5-0.8-2.3-1.6 1.4-1 2.8-1.7 4.7-2.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m295.2 190.3c2.5-1.9 4.6-2.3 4.8 2.3-1.6-0.4-3.1-1.3-4.8-2.3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m331.3 184.5c-0.1-1 0-1.9 0.2-3.2 0.2-0.4 0.5-0.3 0.5-0.3 0.6 0.8 1.1 1.6 1.8 2.7-0.7 0.5-1.5 0.7-2.5 0.8z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m255 175c0 0.5 0 0.9 0 1.9 0 0.8 0 0.9 0 1.1-0.9-0.5-1.8-0.9-2.8-1.7-0.2-0.5-0.1-0.6 0.3-1.1 1.1-0.2 1.8-0.2 2.5-0.2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m270.7 218.7c-0.9 1.1-2 2-3.4 3.1-0.3-2.1-0.5-4.7 3.4-3.1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m337.3 184.2c0.5-0.6 1.3-0.9 2.5-1.2-0.6 0.5-1.5 1-2.5 1.2z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m349.9 63.8c-1.1 0.1-2.1-0.3-3.4-1 0.9 0 2.1 0.3 3.4 1z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m255.1 178.3c-0.1-0.5-0.1-0.6 0-1.1 0.6 0.6 1.2 1.4 1.8 2.5-0.5-0.1-1.1-0.6-1.8-1.4z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m276.8 221.7q-0.5 0.1-1.5-0.5 0.5-0.1 1.5 0.5z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m354.8 210.2c0.2 0.3 0.2 0.8 0.1 1.5-0.2-0.2-0.3-0.8-0.1-1.5z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s67",
    d: "m123.9 191.9c0.1 2.5 0 4.8 0 7.6-0.1 0.8-0.2 1.2-0.8 2-2.4 3.3-4.4 6.1-6.5 8.9-1.6 0.4-3.3 0.9-5.5 1.2-1.4 0.1-2.2 0.2-3.1 0.4-3.4 0.5-6.9 1-10.9 1.5-8.4 1.7-15.3 4.8-20.1 11.4-0.2 0.1-0.4 0.3-0.8 0.4-0.4-0.3-0.7-0.4-1.1-0.4 0 0 0-0.1-0.1-0.3-0.6-0.2-1-0.1-1.9 0-3 0.2-5.6 0.3-8.2 0.4 0 0-0.4-0.1-0.8-0.2-0.5-0.4-0.8-0.6-1.1-0.7-0.7-1-1.4-2.1-2.1-3.8-0.3-4.3-0.6-7.8-0.5-11.3 1.8 2 3.2 4 4.8 6.2 3.4-0.5 6.6-1.3 10.2-2.1 12.1-3.1 23.8-6.1 35.9-9.1 6-0.6 6.6-4.5 6.6-8-2.1 2.1-4.5 4.5-7.3 6.9-12.2 3-23.9 6.1-36 9.1-2.1 0.3-3.9 0.7-5.6 0.6-0.5-1.5-0.9-2.7-1.4-3.8-1.7-3.8-2.9-7.7-0.3-11.7 13.4-3.5 26.2-7.1 39.2-10.4 4.8-1.2 7.7-3 6.6-8.6-0.2-1.4 0.8-3 1.3-4.5 0.8 0.6 1.5 1.3 2.5 2.4 0.8 1.1 1.4 1.6 2 2.1 0 0.1 0.1 0.3 0.4 0.6 0.6 1.9 1 3.5 1.6 5.3 0.4 0.9 0.6 1.6 0.8 2.9 0.7 1.9 1.3 3.1 2 4.3 0 0 0.1 0.5 0.2 0.7zm-32.9 9.4c0.3-3.3-1.2-5.4-4.4-5.2-1.8 0.1-4.3 1.3-5.1 2.7-0.7 1.2 0.6 4.9 1.3 5 2.5 0.3 5.1-0.5 7.6-0.9 0.2 0 0.3-0.5 0.6-1.6zm10.1-2.6c3.5 3.6 5.3 2.7 8.7-5.1-1.8-0.7-4.7-2.5-5.3-1.9-1.7 1.6-2.4 4.2-3.4 7zm-32 3.8c0 1.3-0.2 3.7 0 3.8 2.5 0.4 5 0.5 7.5 0.7q0.2-0.7 0.3-1.5c-2.4-1.1-4.7-2.3-7.8-3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m60 209c0.3 3.5 0.6 7 0.8 11-0.9-1.1-1.8-2.7-2.8-5-0.3-2.4-0.5-4.2-0.7-5.9 0.3-0.5 0.6-1 0.8-2.3 0.2-5.8 0.3-10.8 0.8-15.7 0.6 6.1 0.8 12 1.1 17.9z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m77.3 224.9c4.5-6.6 11.4-9.7 19.4-11.2-6.1 3.8-12.6 7.5-19.4 11.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s68",
    d: "m65 225.4c2.5-0.5 5.1-0.6 8.4-0.7 1.1 0.1 1.4 0.1 1.7 0.1 0 0 0 0.1 0 0.5 0 0.7 0 1 0 1.2-1.7 1.9-3.3 3.9-5.3 6.2-1.9-2.8-3.3-4.9-4.8-7.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m56.9 209c0.6 1.8 0.8 3.6 1 5.7-5.1-1.8-5.6-6.5-6.7-11.3 1.8 1.6 3.6 3.6 5.7 5.6z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m117 210.5c1.7-2.9 3.7-5.7 6-8.7 1.1 6.9-0.2 8.8-6 8.7z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m51.8 196.2c0.2 0.8 0.1 1.7-0.3 2.7-0.2-0.7-0.1-1.6 0.3-2.7z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m108.2 212.2q1-0.5 2.6-0.5-1 0.5-2.6 0.5z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s68",
    d: "m63 224.4c0.3-0.2 0.6 0 0.9 0.4-0.2 0-0.5 0-0.9-0.4z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m75.4 226.4c-0.3-0.1-0.3-0.4-0.3-1 0.4-0.5 0.7-0.4 1 0-0.1 0.5-0.2 0.7-0.7 1z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s69",
    d: "m112.2 147c-0.8 0.9-1.6 1.4-2.7 1.5-1.3-3.2-2.3-6-3.2-9.1 0-1 0-1.7 0.2-2.6-1-3.1-3-3.2-5-0.3-1.3 1.8-2.3 3.8-3.5 5.8-1.9-1.4-3.4-2.5-4.9-3.8-4.4-3.1-6.9-0.6-9.6 2.5-1.8 0.1-3.1 0.1-4.8 0.1-1.5 1.2-2.7 2.5-4.1 3.9-2.1 3.4-4 6.6-6 9.9-0.2 0-0.6 0-0.9 0-0.2 0-0.6 0-0.6-0.4 0-2.9 0-5.2 0-7.9 0-0.7 0-1.1 0-1.5 0.2-6.3 0.4-12.6 0.9-18.9 0.1-1.4 1.3-3.4 2.4-3.7 12.9-3.6 26-7 38.9-10.4 0.6-0.1 1.4 0.2 2.9 0.3 0 11.4 0 22.8 0 34.6z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m118.2 81.5c1.4-1.3 2.7-2.1 5-3.5 0.4 7.3 0.7 13.9 1.1 21-1.7 0-2.9 0.1-4.6 0.2-0.4 0.1-0.6 0.2-0.7-0.3-0.3-1.6-0.6-2.7-0.9-3.8 0-4.4 0-8.8 0.1-13.6z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m122.4 158.7c-2.4-2-4.6-4.3-7.1-6.6-0.7-1.2-1-2.3-1.3-3.7 2.9 3 5.8 6.5 8.4 10.3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m66.7 145c0.4 0.5 0.4 0.9 0.1 1.8-0.9 2.5-1.6 4.4-2.2 6.2-0.6-3.3-1.1-6.7-1.7-10.5 1.2 0.5 2.3 1.5 3.8 2.5z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m117.7 95.1c0.7 1.1 1 2.2 1.3 3.7-1.8 0.2-3.5 0-5.7-0.3 1.1-1.2 2.6-2.3 4.4-3.4z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s59",
    d: "m41.2 342.7c-1.9 1.6-3.6 2.9-5.7 4.2 1.1-10.8 2.5-21.6 3.9-32.9 3-7.6 5.9-14.8 9.2-22-1.2 11-2.8 22-4.3 33.5-0.5 3.6-1.2 6.8-2.3 10.2-1.2 0.6-1.8 1-2.5 1.3q1.2 0.5 2.3 1c-0.1 1.4-0.3 2.9-0.6 4.7zm-0.9-10.2q-0.4 0.3-0.8 0.7c0 0.1 0.2 0.3 0.3 0.4 0.3-0.3 0.5-0.5 0.5-1.1z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m27.1 404.4c0.7 0.3 1.7 1 1.8 1.7 0.1 12.6 0.1 25.2 0.1 37.8 0 2.5-0.2 5-0.6 7.8-0.6-15.4-1-31.2-1.3-47.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m31.8 367.3c-0.1 3.3-0.4 6.9-1.1 10.6 0.1-3.3 0.5-6.8 1.1-10.6z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m34.8 349.3c0.8 2.5 2.6 5.3-1 7.7 0-2.4 0.4-4.9 1-7.7z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m29.9 380.3c1.1 1.7 3.5 3.7-0.3 5.7-0.2-1.7 0-3.5 0.3-5.7z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m28 395.4c0.1 1.5 0.1 3.5-0.2 5.5-0.2-1.6 0-3.4 0.2-5.5z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m32.8 361.2c0.2 0.8 0.2 1.7-0.1 2.7-0.2-0.7-0.2-1.6 0.1-2.7z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m28.8 389.2c0.2 0.7 0.2 1.7-0.1 2.8-0.2-0.8-0.2-1.6 0.1-2.8z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s71",
    d: "m396.3 160.7c-4.4 0.5-3.7-2.1-2.8-4.3 1.1-2.6 2.8-4.9 3.9-7.5 0.4-0.8 0.1-2.3-0.4-3.1-0.2-0.4-1.9-0.3-2.7 0-2.2 1.1-4.2 2.5-6.5 3.5-2.2 1.1-4.6 2-6.9 3q-0.5-1-1.1-1.9c3.5-3 6.9-6.1 10.6-8.8 1.2-1 3.1-1.2 4.7-1.4 4.4-0.5 7.5 2.2 6.5 6.5-1 4.7-3.2 9.2-5.3 14z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m67.1 154.9c0 0 0.4 0 0.6 0.4 0 1.5-0.1 2.7-0.2 3.6 3 0.4 5.6 0.7 7.7 1-4.8 0.1-9.1 0.5-10.6 6.1-1.4 2.9-2.8 5.6-3.6 8.5-1.1 4.1-1.7 8.4-2.6 12.2-0.5-0.8-0.8-1.3-1.2-1.8 0-0.4 0-0.8 0.3-1.6 0.3-1.1 0.3-1.7 0.3-2.3q2.6-10.3 5.2-20.5c0.4-1.6 0.7-3.3 1.5-5.2 1.2-0.4 1.9-0.4 2.6-0.4z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m56.9 185c0.7 0.4 1 0.9 1.4 2.1 0.1 1.8 0.2 2.8 0.2 3.9-0.1 5-0.2 10-0.5 15.5-0.5-6.8-1-14.1-1.1-21.5z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m67.1 154.5c-0.7 0.4-1.4 0.4-2.4 0.5-0.4-0.5-0.4-0.9-0.2-1.7 0.7-2.1 1.4-4 2.3-6.2 0.3 2.2 0.3 4.5 0.3 7.4z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m50.5 173.9c-0.4-1.3-0.4-2.7-0.5-4.5 0.5-0.6 1-0.9 1.7-1.3-0.1 1.8-0.5 3.8-1.2 5.8z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m57.5 181c0.3 0.6 0.3 1.2 0 2-0.3-0.6-0.3-1.2 0-2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m260.5 94.9c-0.7 8.2-1.7 16.5-3.1 25 0-6.6 0.2-13.3 0.7-20 0.2-1.7 1.3-3.2 2.4-5z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m256.7 122.3c0.8 0.9 1.3 2.1 2 3.9-0.1 4.7-0.4 8.7-0.7 12.8-0.8 0.5-1.6 1.1-2.7 1.8 0.2-5.9 0.7-12.1 1.4-18.5z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m255 146.4c0.2 1.1 0.3 2.6 0.2 4.4-0.3-1.2-0.3-2.6-0.2-4.4z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m255 174.7c-0.7 0.3-1.4 0.3-2.5 0.3-0.3-0.5-0.4-0.9-0.2-1.8 0.4-0.7 0.6-0.9 0.7-1.2 0.7 0.8 1.3 1.6 2 2.7z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m253 171.6c-0.1 0.7-0.3 0.9-0.7 1.3-0.3-1-0.3-2-0.3-3.5 0-0.4 0.5-0.4 0.7-0.4 0.3 0.8 0.3 1.5 0.3 2.6z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m83.1 81.5c0.3-0.6 0.5-0.8 0.8-1.2 0.6-0.2 1-0.3 1.8-0.3 2.1 0.9 3.8 1.8 5.9 2.8 0.9 3 1.4 5.9 2.1 8.7 1.9 8.2 0 10.6-9.2 10.6-0.7-2.4-0.4-5.2-1.5-7.1-2.8-4.6-0.2-8.8 0.1-13.5z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m61 118.2c-0.4 6.1-1.2 12.1-2.1 18.5-1.8 4.6-5.3 0.7-7.6 2.2-0.6-1.3-1.3-2.6-1.6-3.9-0.7-3.6-1.3-7.2-2.3-10.9-0.7-1.7-1.7-3.6-1.2-4.9 0.9-2.1 2.4-4.3 4.3-5.6 0.9-0.6 3.2 0.5 4.7 1.2 1.9 0.9 3.7 2.2 5.8 3.4z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m304.7 45.9c2.3 0.4 4.4 0.5 6.4 1.2 2.6 0.9 5.6 1.6 7.6 3.3 4.8 4 10.2 5.7 16.1 6.7 1.1 0.2 2.1 1.3 3.2 2.3-0.3 0.7-1 1.3-0.9 1.4 3.5 5.3 6.4 11.3 10.8 15.8 6.4 6.5 7.3 10.1 1.4 16.8-1.4 1.5-3 2.9-0.4 5.5 1.1 2.2 2 3.7 2.9 5.2 0.3 0.1 0.7 0.2 1.1 0.9 0 5.1-4.2 2.6-6 4.2-0.5-0.2-1-0.4-1.8-1.2-0.2-1.3-0.2-2.1 0.1-3.2-0.3-1-0.7-1.9-1.3-3.2-1-0.7-2-1.2-3.4-1.6-2.4 0-4.5 0-6.8-0.3-2.4-0.1-4.5 0.1-7.1 0.3-1.8 0-3.2 0-4.8-0.3-1.1-0.4-2-0.5-3.3-0.7-3.2 0-6.7-0.9-6.8 3.9-1.8-0.1-3.1-0.2-4.7-0.4 0.4-1.9 0.7-3.2 1.1-4.7 0.4-0.8 0.7-1.3 1.4-1.8 3.1-1 5.8-2 8.5-3 0 0 0 0 0.3-0.2 0.7-1.3 1.8-3 1.4-3.5-2.9-4-1-7.8-0.1-11.7 0.2-1.1-0.4-2.4-0.6-4 0-1.5 0-2.5 0.3-3.8-0.3-1.5-0.8-2.6-1.4-4.1-0.4-1.1-0.7-1.9-1-3-1.3-1.2-2.6-1.9-3.9-2.7 0 0 0 0 0-0.4-0.8-1-1.5-1.8-2.5-2.5-3.1 1.7-5.8 3.3-8.8 4.9-2.1 0.7-3.9 1.3-5.6 1.6-0.8-1.1-1.4-1.9-2.1-3-0.7-0.1-1.4 0.1-2 0.3 0 0.1-0.1 0.1-0.4 0.1-0.3 0.7-0.4 1.4-0.6 2.3-0.4 0.8-0.7 1.2-1.4 1.7-1.9 0-3.3 0-5 0.1-0.8-0.1-1.2-0.1-1.7-0.5-1.3-0.2-2.7 0-4.2 0.2-0.4 0.1-0.6 0.1-0.8 0.2-1.4 0.4-2.8 0.8-4.7 1.4 1.4-2.4 2.6-4.5 3.9-7 0.3-0.5 0.5-0.7 0.8-1.1 0.5-0.4 0.7-0.6 1-1.1 0.5-0.3 0.7-0.5 1-1 0.5-0.3 0.7-0.5 1-1 0.4-0.3 0.7-0.5 1-0.9 1.5-0.6 3.3-0.6 4.3-1.5 4.7-4.2 10.3-5.7 16.5-6.6 0.8-0.3 1.2-0.3 2-0.3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m317 63.1c0.2 0.7 0.5 1.5 0.9 3 0.4 1.7 0.8 2.8 1.1 3.9 0 1.1 0 2.1-0.2 3.9-1.8 6.6-5.2 12.5-0.8 18.6 0.1 0.1 0 0.3 0 0.5 0 0 0 0-0.4 0-2.9-0.5-5.3-1.1-8.5-1.8 0 1.7 0 3.3 0 4.8-0.3 0.5-0.6 1-1.4 1.8-1.5 0.1-2.5 0-3.5-0.5-0.1-1.3-0.1-2.3-0.2-3.7 0-1.5-0.1-2.5-0.1-3.9-1-0.1-2 0.1-3.2 0.5-0.4 0.7-0.5 1.2-1.1 1.8-1-0.1-1.7-0.2-2.4-0.6-0.1-1.4-0.1-2.4-0.2-3.8-0.9-1.5-1.9-2.6-3.1-3.9-1.1 0.9-1.9 2.1-2.8 3.7 0 2.2 0 3.9 0 5.6-3.2 4.5-4.7 4.9-7.2 1-0.2-4.1-0.5-7.4-0.8-10.7q-0.8-0.1-1.7-0.1-0.7 1.4-1.4 2.8c-0.5-0.2-1-0.4-1.9-1.1-0.5-4.5-4.2-2.7-6.2-3.9 0.4-3 0.8-6 1.2-9.4 1.6-2.3 3.1-4.1 4.7-6.3 0.3-0.4 0.5-0.4 1.3-0.4 1.7 0 2.8 0 3.9 0 0.4 0.1 0.8 0.1 1.7 0.5 2.6 3.7 4.2 3.3 5.3-0.4 0.3-0.5 0.6-0.9 1.2-1.9 0.4-1 0.6-1.6 0.7-2.1 0 0 0.1 0 0.4 0 0.8-0.1 1.3-0.1 1.7-0.1 0.7 0.8 1.3 1.6 2.1 3.1 3.9 3.8 4.8 0.7 5.9-2 2.7-1.6 5.4-3.2 8.5-4.5 1.1 1 1.8 1.7 2.5 2.5 0 0 0 0 0.1 0.3 1.4 1.1 2.6 1.9 3.9 2.8z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m253.8 158.1q0.2 0.3-0.5 0.8-0.2-0.3 0.5-0.8z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m102.8 420.6c-0.5-2.6-1.3-5.6-1-8.5 0.3-2.4 2.1-4.6 3.5-7.5-3.6-1.1-5.1 0.2-6.4 3-1.5 3.5-3.4 6.9-5.5 10 2.4-6.7 5-13.2 8-19.4 5-10.3 10-20.5 10.3-32.3 1.6-7.5 3.1-15.1 5.3-22.6 0.8 8.3 1.1 16.6 1.1 24.9-0.1 3.6-0.7 7.2-1 10.8-2.7 7.1-5.6 14.2-8.1 21.3-2.3 6.6-4 13.3-6.2 20.3z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m111.4 366c0 11.7-5 21.9-10 32.2-3 6.2-5.6 12.7-8.3 19.4-0.3 0.9-0.6 1.5-1.1 2.2-0.7-2.3-2.2-5-1.7-7.2 1.6-7.2 4-14.1 6.5-21.3 0.7-0.6 1-1 1.2-1.4 0 0 0 0.1 0.3 0 0.4-0.7 0.5-1.4 0.7-2 0 0 0 0.1 0.3 0.2 0.8-0.7 1.2-1.4 1.7-2.2 0 0 0 0.1 0.3 0 2.4-3.4 6.8-5.8 4.8-10.8 1.6-3 3.3-6 5.3-9.1z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m117.4 378.9c0-3.5 0.6-7.1 0.7-10.7 0-8.3-0.3-16.6-0.8-25.2-0.7-2.2-1-4.2-1.3-6.6 1.5 0.7 3.6 1.3 4.4 2.7 5.4 9.2 4.1 18.9 1.8 28.5-1 3.9-2.9 7.5-4.8 11.3z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m40.5 422.6c-0.5-0.7-1.4-1.8-1.4-2.9 0-5.2 0.3-10.4 0.9-15.7 0.5 6 0.6 12.1 0.5 18.6z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m81.6 462c-1.8 3.8-9.3 4.4-13.5 0.7 4.3-0.4 8.7-0.6 13.5-0.7z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m105.8 375.4c2.3 4.7-2.1 7.1-4.5 10.5 1.2-3.4 2.8-6.8 4.5-10.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m39.8 397.7c-2.8-0.7-3.9-2.1-1.1-4.6 0.5 0.4 0.7 1 1.1 1.7 0.2 1 0.2 1.7 0 2.9z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m92.3 436.3c0.5 1.3 0.9 2.9 1.1 4.6-0.6-1.3-0.9-2.8-1.1-4.6z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m66.4 461.5c-1.6-0.6-3.4-1.4-5.3-2.6 1.8 0.4 3.4 1.4 5.3 2.6z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m49 447.7c-1.1 0-2.3-0.2-3.5-0.5 0.4-0.6 0.7-1.3 1.3-2.1 0.9 0.7 1.5 1.5 2.2 2.6z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m56.8 455.7c-1.1-0.5-2.4-1.3-3.7-2.5 1.2 0.5 2.4 1.4 3.7 2.5z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m51.3 450.6c-0.7-0.4-1.5-1.1-2.3-2.3 0.7 0.4 1.5 1.2 2.3 2.3z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m100.6 385.8c-0.1 0.9-0.5 1.6-1.3 2.2 0.1-0.8 0.6-1.6 1.3-2.2z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m98.7 388.1q0.2 0.7-0.4 1.8-0.3-0.7 0.4-1.8z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m97.8 390c0 0.3-0.3 0.7-0.7 1.1 0-0.4 0.2-0.7 0.7-1.1z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m91.4 424.5q0.3 0.3 0 1.2-0.3-0.2 0-1.2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m42.1 433.8c-0.2 0-0.4-0.3-0.4-0.6 0.2 0 0.3 0.1 0.4 0.6z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s74",
    d: "m65 166c1.1-5.6 5.4-6 10.4-5.8 2.9 2.8 3.2 1.3 3.8-0.9 0.8-3 2.4-3.1 4.1-0.1 2 0.5 3.9 0.7 6 0.8 0.2 0 0.6-0.2 1-0.1 1.9-1.6 3.6-3.2 5.2-4.7 2.5-2.5 4.9-4 7.7-0.4 0.6 0.7 1.7 0.8 2.6 1.2-0.5 7.3 4.5 11.8 8.5 17.2-0.4 1.9-1.4 3.5-1.2 4.9 1.1 5.6-1.8 7.4-6.6 8.6-13 3.3-25.8 6.9-39.2 9.9-0.4-8.5-0.4-16.6-0.5-24.8-0.2-0.5-0.4-0.7-1-0.9-0.5-1.8-0.6-3.4-0.8-4.9z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m105.9 155.7c-1-0.1-2.1-0.2-2.7-0.9-2.8-3.6-5.2-2.1-7.7 0.4-1.6 1.5-3.3 3.1-5.3 4.3-1.3-1-2.3-1.7-2.9-2.4 1.8-0.8 3.2-1.4 5-2.2 2.2-1.2 4.1-2.2 5.8-3.6 0.4-0.3 0.1-1.5 0.4-2.4 1.8-0.2 3.2-0.5 4.5-0.4 1 1.4 2 2.4 3.1 3.6 0.1 0.1 0.3 0.3 0.3 0.3-0.2 1-0.3 2-0.5 3.3z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m106.3 139.7c0.9 2.8 1.9 5.6 2.8 8.8-0.7 1.5-1.4 2.5-2.5 3.8-0.2 0.1-0.4-0.1-0.5-0.6 0.1-4.3 0.1-8.2 0.2-12z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m119 160c1.3 1.4 2.7 2.9 4 4.7-1.6-0.8-3.1-2-4.8-3.6 0.2-0.8 0.5-1 0.8-1.1z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m114.4 152.9c0.7 1.1 1.1 2.2 1.6 3.7-0.6-0.9-1.3-2.3-1.6-3.7z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m118.9 159.7c-0.2 0.4-0.5 0.6-0.8 1.1-0.8-0.9-1.5-2-2.1-3.4 0.9 0.4 1.8 1.2 2.9 2.3z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m118.9 177.7q-1-0.2-1.8-1.5 1 0.3 1.8 1.5z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m39.3 371.7c-0.7-4.3-1.4-9-1.9-13.8 0-0.2 1-0.6 1.9-0.9 0.3 4.8 0.3 9.5 0 14.7z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m39.1 384.6c-2.7-0.5-2.7-1.8-0.4-3.5 0.4 1 0.4 2 0.4 3.5z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m40.3 349.8c-0.2-1-0.3-2.3 0-3.7 0.3 1 0.2 2.2 0 3.7z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m41.9 337.7c-0.8-0.1-1.6-0.4-2.4-0.7 0.7-0.3 1.3-0.7 2.2-1 0.4 0.5 0.4 0.9 0.2 1.7z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m123.7 190.9c-0.7-0.9-1.3-2.1-1.9-3.6 0.7 0.9 1.4 2.1 1.9 3.6z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m100.2 444.7c-1.9-4-1.1-8 1.9-11.7-0.4 3.7-1.1 7.5-1.9 11.7z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m102.6 428.6c-0.3-1.5-0.5-3.4-0.4-5.5 0.4 1.6 0.5 3.4 0.4 5.5z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m99.4 448.8c-0.2-0.4-0.2-1 0-1.8 0.2 0.5 0.2 1.1 0 1.8z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m96.6 450.1c-0.3 0.5-0.6 0.8-0.9 1.1q-0.2-0.5-0.5-1c0.5-0.2 0.9-0.3 1.4-0.1z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m93.5 452.5c0 0-0.1 0 0 0z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m328 122c-2.5-0.3-5.5-1.4-7.6-0.5-2.1 0.9-3.3 3.9-4.5 5.5-1.4-2.2-3.2-5-5.4-8.4 0.1-5.4-2.7-7.8-6.7-9.9-1.7-0.9-2.6-3.4-3.4-5.4-0.2-0.4 1.8-1.6 2.8-2 2.2 6 7.1 2.7 11.2 3.6 3.4 0.2 6.3 0.3 9.3 0.7-1.2 3-2.4 5.7-3.7 8.7 0.9 0.9 1.7 1.6 2.7 2.5 2.2 0.8 4.2 1.3 6.3 1.7 2.4 1.1 4.9 2 7.3 3.2 1.7 0.9 3.1 2.2 4.4 3.6-4.4-1-8.6-2.2-12.7-3.3z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m324.9 137.2c4.1 0.5 8.2 2.2 12.3-1.4 5.6 3.5 7.6 3 13.8-3.7 5.8-1.4 6.1-1.1 5.9 5.6-0.2 0.2-0.6 0.3-0.7 0.6-2.3 7.8-8.3 6.9-14.3 6.1-4.4-0.6-8.9-1-14-1.4-2.4-0.1-4-0.4-6.1-0.7 1.5-2.4 2.3-3.8 3.1-5.1z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m320 114c1.3-2.7 2.5-5.4 4.2-8.5 7.2-0.4 14-0.4 20.8-0.5-0.1 0.9-0.1 1.7-0.1 2.8-2.9 0.5-5.8 0.6-8.8 0.8q-0.1 0.9-0.2 1.8c1.9 0.7 3.8 1.2 5.7 2 2.5 1.1 5.1 2.2 7.5 3.7 0.7 0.4 0.8 1.9 1.2 2.8-1 0.2-2.1 0.6-3 0.5-3.3-0.5-6.5-1.2-10-2.4-2-1.7-3.5-3.7-5.1-3.8-4-0.2-8.1 0.4-12.2 0.8z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m324.7 137c-0.6 1.5-1.4 2.9-2.9 5.3 2.1 0.3 3.7 0.6 5.7 0.7 2.6 3.3 5 6.7 7.7 10.3 0.2 0.4 0.1 0.7-0.4 1.4-0.9 1.1-1.3 1.7-1.8 2.4-0.4 0-0.8 0-1.9 0-1.2 0-1.7 0-2.2 0-0.4 0-0.9 0-1.6-0.4-1.7-1.5-3-2.6-4.3-3.7-0.5-0.9-1-1.8-1.8-3.2-0.9-1.3-1.5-2.1-2.1-2.8-0.4-2-0.8-4-1.2-6.8-0.3-1.6-0.6-2.4-1-3.2 0-0.4 0-0.8 0-1.9 0.1-1.1 0.1-1.6 0.1-2.1 0.4 0 0.9 0 1.7 0.3 1 0.8 1.7 1.2 2.3 1.7 1.2 0.6 2.3 1.2 3.7 2z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m357.3 137.7c-0.2-6.7-0.5-7-6-5.7 0.8-2.6 1.6-5.3 3.1-7.7 0.9-1.3 3-2.9 4.1-2.7 1.5 0.4 3.2 2.4 3.6 3.9 1.1 4.9 0.2 9.3-4.8 12.2z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m320 114.3c4.1-0.7 8.2-1.3 12.2-1.1 1.6 0.1 3.1 2.1 4.7 3.6-1 0.6-2.1 0.7-3.5 0.5-3.8-4.1-7.4-0.4-10.9-0.8-0.8-0.6-1.6-1.3-2.5-2.2z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m347.1 109.5c1.6-1.9 5.8 0.6 5.9-4.3 1.1 0.4 2.7 0.9 3.1 1.9 0.6 1.3 0.8 3.3 0.2 4.5-0.4 0.8-2.7 1.2-3.8 0.9-1.9-0.5-3.5-1.7-5.4-3z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s68",
    d: "m328 122.3c4.1 0.8 8.3 2 12.8 3.4 1 0.6 1.6 1.1 2.2 1.6q-0.2 0.6-0.5 1.2-4.8-1.6-9.7-3.3c-1.4-0.4-2.7-0.9-4.4-1.3-0.4-0.5-0.4-0.9-0.4-1.6z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m322.7 116.8c3.3 0.1 6.9-3.6 10.3 0.5-1 0.5-2.1 0.7-3.6 1.1-2.5-0.3-4.5-0.8-6.7-1.6z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m351.8 103.7q-1.4-1.7-2.7-4.5 1.4 1.6 2.7 4.5z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m299 138.9c0 0-0.5 0.1-1.1 0.1-2.9 2.1-5 4.4-8.8 3.4-1.1-0.2-2.8 2.3-4.5 3.5-0.7 0.1-1.1 0.1-1.7-0.1-1.5 0.9-2.7 2-4 3.2-2.5 3.3-4.9 6.8-7.6 10.1-0.6 0.8-2.2 0.8-3.3 1.1-0.3-1.2-1.1-2.7-0.6-3.6 1.7-3.2 3.8-6.2 5.7-9.4 0.9-1.5 1.8-3.1 2.7-4.7 1.8-3.2 3.9-5.6 7.8-6.9 2.4-0.9 3.7-5 5.7-8.3 2.1-4.8 4.1-9 6.4-13.3 3.8-2 5.6 0.2 7.7 3-1.6 1.4-3 2.7-4.4 4 0 0 0 0-0.3 0-0.8 0.7-1.2 1.4-1.7 2 0.1 1.7 0.1 3.4 0.1 6 0.7 3.2 1.3 5.6 1.9 8.3 0 0.7 0 1.2 0 1.6z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s77",
    d: "m263.4 185c0.7-3.4 1.7-6.8 2.7-10.5 1-2.4 2-4.3 3.3-6.7 0.8-0.9 1.2-1.3 1.7-1.8 0 0-0.1 0 0.2 0 1.3-1 2.1-1.9 3.4-2.9 5.3-2.8 10.2-5.7 16.4-4.9 0.3 0.5 0.5 0.7 0.7 0.9 0.6 2.4 1.2 4.8 2 7.9 1.2 1.7 2.3 2.8 3.3 3.9 0.1 0.2 0.2 0.4-0.1 0.8-1.9 0.3-3.5 0.4-5.6 0.3-3.2-0.1-6-0.1-8.8 0-6.3 0.1-10.9 2.3-10.2 9.9-0.8 0-1.1 0.1-1.4 0.1-2.4 1-4.8 2-7.6 3z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m292.2 159c-0.6-0.1-0.8-0.3-1.1-1.2-5.8-5.5-5.8-5.5-12.1-0.7-0.5-0.5-0.8-0.8-1-1.1 0.5-0.9 1-1.7 2.1-2.9 0.5-0.7 0.5-1.3 0.5-1.8 0.4-0.3 0.8-0.7 1.6-1.3 0.5-1.5 0.7-2.7 0.8-3.9 0.5-0.1 0.9-0.1 2 0 4.1-0.3 7.5-0.7 11-1.1 2.3 1.4 4.7 2.7 7 4.1 1.5 0.9 3.6 1.5 4.3 2.9 2.2 4.6 4.5 3.8 8-0.8-0.3 2.8-0.5 4.1-0.9 5.6-2.9-0.2-5.8-0.3-8.3-1.3-5.5-2.1-9.9-1.2-13.9 3.5z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m299.3 121c1.1-1.3 2.5-2.6 4.1-4-2.1-2.8-3.9-5-7.8-3.4 1.1-4.2 2.5-8-2.6-10.5 1.4-3.2 3.8-6.4 0.3-10.4-0.9-2.3-1.5-4-2.1-5.7 0.8-1.2 1.6-2.4 2.7-3 1.2 1.7 2.2 2.9 3.1 4 0.1 1 0.1 2 0.1 3.8 0.6 2.2 1.2 3.8 1.9 5.5 0.4 0.6 0.7 0.9 1.1 1.2 0.3-0.5 0.6-1 1.2-1.7 0.4-1.1 0.5-1.9 1-2.8 0.8 0 1.3 0 1.7 0 0.1 1 0.1 2 0.1 3.7-0.3 1.5-0.6 2.3-0.9 3.2-1 0.8-3 2-2.8 2.4 0.8 2 1.7 4.5 3.4 5.4 4 2.1 6.8 4.5 6.4 9.8-3.4 1.1-6.9 1.8-10.9 2.5z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m293 103.4c5.1 2.2 3.7 6 2.3 10.3-1.9 4.6-3.9 8.8-6 13.3-0.8-1.3-1.4-2.9-1.9-5.1 0.3-2.5 0.5-4.4 0.7-6.2-1.6-0.2-3.2-0.4-4.8-0.3-1.1 0-2.2 0.4-3.3 0.3 0-0.2 0-0.7 0-0.7 0.2-1.1 0.9-2.6 0.4-3.3-2.3-3.6-0.3-4.1 2.7-4.7 3.3-0.8 6.6-2.1 9.9-3.6z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m258 139.4c0.3-4.5 0.6-8.5 0.9-13 1.3 0.7 2.9 1.5 3.5 2.8 1.6 4 3.1 7.8 8.2 8.2 0.3 0 1 3.1 0.3 3.9-3.1 3.9-6.6 7.5-10.9 12.3-0.8-5.1-1.4-9.4-2-14.2z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m280 116c1.1-0.2 2.2-0.6 3.3-0.6 1.6-0.1 3.2 0.1 4.8 0.3-0.2 1.8-0.4 3.7-0.8 5.8-6.3 1-12.4 1.8-18.6 2.4-0.3 0-0.8-1.6-0.6-2.8 4.4-1.9 8.1-3.5 11.9-5.1z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s79",
    d: "m280 115.7c-3.8 1.9-7.5 3.5-11.6 5.1-1.8-5.4-0.9-6.7 4.7-6.8 2.1 0 4.2 0.3 6.6 0.7 0.3 0.3 0.3 0.8 0.3 1z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m280.3 86.2c0.2-1.1 0.6-2.1 1.1-3q0.9 0 1.7 0.1c0.3 3.3 0.6 6.6 0.8 10.3-1.1-2.1-2.2-4.7-3.6-7.4z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m277.7 156.1c0.5 0.2 0.8 0.5 1.1 1.2-1.4 2.3-2.9 4.1-4.5 5.9-0.9 0.9-1.7 1.8-2.9 2.8 1.7-3.2 3.8-6.5 6.3-9.9z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m271.7 81.2c2.2 1 5.9-0.8 6.1 3.7-2-0.9-4.2-2.2-6.1-3.7z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m282.9 145.8c0 1.5-0.2 2.7-0.6 3.9-0.8-0.1-1.3-0.2-2.6-0.6 0.5-1.3 1.7-2.4 3.2-3.3z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m291.1 87.4q1 2 1.9 5.2c-0.5 0.4-0.9 0.4-1.6 0.4-0.3-1.7-0.3-3.4-0.3-5.6z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m270.7 165.9c-0.1 0.6-0.5 1-1.3 1.5 0.1-0.5 0.5-1 1.3-1.5z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m280.4 151.7c0.2 0.1 0.2 0.7-0.1 1.2-0.2-0.2-0.2-0.5 0.1-1.2z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m332.3 180.8c-0.3 0.2-0.6 0.1-0.8 0.1-3-3.6-5.5-7.6-8.9-10.6-3.5-3.1-7.9-5.2-11.9-7.7 0.1 0 1.2-0.8 2.6-1.7 4.7 0.1 7.7 2.4 10.4 6.1 1.9 2.7 5.2 4.4 7.6 6.9 1.7 1.8 4.1 3.9 1 6.9z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m296 144.7c-3.5 0.7-6.9 1.1-10.7 1.4 1-1.4 2.7-3.9 3.8-3.7 3.8 1 5.9-1.3 8.5-3.3-0.3 1.7-0.9 3.4-1.6 5.6z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m299.3 139c-0.3-0.5-0.3-1 0-1.7 0.8-0.3 1.3-0.3 1.7-0.3 2.6 2.6 8.3 1.5 8.6 7.7-5.2 1.2-6.2-4.8-10.3-5.7z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m300.9 136.6c-0.3 0.4-0.8 0.4-1.5 0.4-1-2.4-1.6-4.8-2.2-7.6 4.9 0.2 1.7 4.8 3.7 7.2z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m323.1 153.3q1.9 1.2 3.9 3.3-1.9-1.1-3.9-3.3z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m316.7 137.2c0.6 0.6 0.9 1.4 1.2 2.6-0.5-0.5-1-1.5-1.2-2.6z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m319.1 147.3q0.9 0.7 1.9 2.3-0.9-0.6-1.9-2.3z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m321 134.7q-0.9-0.2-2-1.4 0.9 0.2 2 1.4z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m316.7 133c0.3 0.5 0.3 1 0.2 1.8-0.2-0.3-0.3-1-0.2-1.8z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m297.4 122.9q0.1-0.8 1.3-1.9-0.2 0.9-1.3 1.9z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m329 157.4c0.4-0.3 0.9-0.3 1.8-0.3-0.4 0.2-1.1 0.4-1.8 0.3z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m333.4 157q0.1-0.9 1.3-2-0.2 0.9-1.3 2z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m291.9 172.1c1.6 0 3.2-0.1 5.3-0.1 2.4-0.2 4.4-0.3 6.6-0.2-1.3 1-2.9 1.9-5.1 3.1-2.6 0-4.7-0.3-6.7-1 0-0.8 0-1.3-0.1-1.8z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m297.1 170.5q-1.5-1.1-3.1-3.2 1.6 1.1 3.1 3.2z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s81",
    d: "m291.9 174.3c2.1 0.3 4.2 0.6 6.6 0.9 5.7 2 10.9 4 16.3 6.6 0.2 0.8 0.2 1 0.2 1.2-1 0.8-2 2.5-2.9 2.4-6.8-0.9-13.5-2.1-21.1-3.3-2.9 0.1-5.1 0.7-7.1 0.3-1.5-0.3-2.7-1.8-3.9-3 4.1-1.9 8-3.5 11.9-5.1z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s79",
    d: "m279.8 179.7c1.4 0.9 2.6 2.4 4.1 2.7 2 0.4 4.2-0.2 6.7-0.3 0.4 1.7 0.4 3.4 0.4 5.4-0.6 0.3-1.1 0.1-1.9-0.3-0.7-1.2-1.4-2.9-1.6-2.8-3.9 1.1-8.9-0.5-11.2 4.7-0.5 1.1-2.3 1.7-3.5 2.5-0.6-1.2-1.5-2.4-1.7-3.8-0.3-1.6-0.1-3.2-0.1-5.3 0.3-0.5 0.6-0.6 1.5-0.4 1.5 0.5 2.6 1.2 3.1 0.9 1.5-0.9 2.8-2.2 4.2-3.3z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s79",
    d: "m315.4 183c-0.4-0.2-0.4-0.4-0.4-0.9 1-0.1 1.9 0.1 3 0.6-0.6 0.3-1.4 0.3-2.6 0.3z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m66.8 172c0.1 8 0.1 16.1 0.1 24.6-2.2 4.5-1 8.4 0.7 12.2 0.5 1.1 0.9 2.3 1.1 4-1.4 1.1-2.6 1.6-3.7 2.2-1.4-2-2.8-4-4.6-6-0.7-5.9-0.9-11.8-1.5-17.9-0.4-1.2-0.5-2.2-0.5-3.7 0.9-4.5 1.5-8.8 2.6-12.9 0.8-2.9 2.2-5.6 3.6-8.5 0.6 1.5 0.7 3.1 1.3 5.1 0.5 0.6 0.7 0.8 0.9 0.9z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s69",
    d: "m91 201.7c-0.3 0.7-0.4 1.2-0.6 1.2-2.5 0.4-5.1 1.2-7.6 0.9-0.7-0.1-2-3.8-1.3-5 0.8-1.4 3.3-2.6 5.1-2.7 3.2-0.2 4.7 1.9 4.4 5.6z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m75 212c11.7-3 23.4-6.1 35.6-8.8 0.4 0.4 0.4 0.6 0.4 0.8-11.8 3-23.5 6-35.6 8.8-0.4-0.4-0.4-0.6-0.4-0.8z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m101 198.4c1.1-2.5 1.8-5.1 3.5-6.7 0.6-0.6 3.5 1.2 5.3 1.9-3.4 7.8-5.2 8.7-8.8 4.8z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s74",
    d: "m69.5 202.3c2.7 0.9 5 2.1 7.4 3.2q-0.1 0.8-0.3 1.5c-2.5-0.2-5-0.3-7.5-0.7-0.2-0.1 0-2.5 0.4-4z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s83",
    d: "m111.3 204c-0.3-0.2-0.3-0.4-0.3-0.8 2.4-2.7 4.8-5.1 6.9-7.2 0 3.5-0.6 7.4-6.6 8z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s83",
    d: "m74.6 212c0.4 0.2 0.4 0.4 0.4 0.8-3.2 1.1-6.4 1.9-9.8 2.4 0.9-0.8 2.1-1.3 3.5-2 2-0.5 3.8-0.9 5.9-1.2z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m75 224.6c-0.2 0.2-0.5 0.2-1.1 0.1 0.1-0.2 0.5-0.3 1.1-0.1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m87 157.1c0.9 0.7 1.9 1.4 2.9 2.4 0 0.3-0.4 0.5-1 0.5-2.3-0.4-4-0.7-5.7-1.1-1.6-2.7-3.2-2.6-4 0.4-0.6 2.2-0.9 3.7-3.4 1-2.7-0.7-5.3-1-8.3-1.4q0.1-1.3 0.4-3.6c0.1-0.4 0.5-0.4 1-0.4 1.1 0 1.6 0.1 2.3 0.4 2-0.4 5.1-0.8 5.3-1.9 0.5-1.8-0.9-4-1.5-6.5 0-1-0.1-1.5-0.1-2.1 1.1-1.2 2.3-2.5 3.8-3.2 0.3 4.3 0.3 8.1 0.3 11.9q0.9 0.1 1.8 0.2c1-4 2.1-7.9 3.4-11.6 0.4 1.2 0.6 2.1 0.8 3.3 0 0.7 0 1.2-0.2 1.7-0.2 0.2-0.3 0.3-0.3 0.4 0.1 0.2 0.3 0.3 0.4 0.9 0.7 3.2 1.4 6 2.1 8.7z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m93.2 138.8c1.4 1 2.9 2.1 4.8 3.5 1.2-2 2.2-4 3.5-5.8 2-2.9 4-2.8 4.7 0.3-5-0.1-1 3.2-2.6 4.3-2 2-3.6 4-5.7 5.9-1.9-2.7-3.4-5.3-4.9-8 0.1-0.1 0.2-0.2 0.2-0.2z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m83.9 141.9q-1.6 5.9-3.1 11.8-0.9-0.1-1.8-0.2c0-3.8 0-7.6 0-11.9 1.4-0.5 2.7-0.5 4.5-0.4 0.4 0.3 0.4 0.7 0.4 0.7z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m84.2 142.1c-0.3-0.2-0.3-0.6-0.3-0.9 2.3-3.3 4.8-5.8 9.2-2.7 0.1 0.3 0 0.4-0.3 0.5-0.3 1.5-0.1 2.8-0.3 4.1-4.1-4.3-5.5-0.2-7.4 2-0.3-0.9-0.5-1.8-0.9-3z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m103.9 141c1.3-1-2.7-4.3 2.1-4 0.3 0.7 0.3 1.4 0.3 2.4-0.1 4.1-0.1 8-0.2 12.2-1.1-0.7-2.1-1.7-2.8-3.4 0.3-2.8 0.5-5 0.6-7.2z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m71 155c-0.5 0-1-0.1-1.9-0.1 1.5-3.3 3.4-6.5 5.5-9.9 0.3 0.4 0.4 0.9 0.4 2.2-1.4 3.1-2.7 5.4-4 7.8z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m40.4 332.6c-0.1 0.5-0.3 0.7-0.6 1-0.1-0.1-0.3-0.3-0.3-0.4 0.2-0.2 0.5-0.5 0.9-0.6z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m345.2 104.8c-7 0.3-13.8 0.3-21.1 0.4-3.4 0-6.3-0.1-9.7-0.6-1.1-0.8-1.7-1.3-2.3-1.7-0.3-4.8 3.2-3.9 6.6-3.6 1.6 0.4 2.4 0.5 3.3 0.7 1.4 0 2.8 0 4.9 0.3 2.8 0 4.9-0.1 7.1-0.3 2 0 4.1 0 6.7 0.3 1.5 0.7 2.4 1.2 3.3 1.7 0.5 0.9 0.9 1.8 1.2 2.8z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m318.3 92.8c-0.3 0-0.2-0.2-0.3-0.3-4.4-6.1-1-12 0.8-18.2 0.4 0.9 1 2.2 0.8 3.3-0.9 3.9-2.8 7.7 0.1 11.7 0.4 0.5-0.7 2.2-1.4 3.5z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m311.7 102.9c1 0.4 1.6 0.9 2.3 1.6-3.7-0.5-8.6 2.8-10.8-3.2 0.3-1.3 0.6-2.1 0.9-3.3 1.1-0.2 2.1-0.1 3.5 0 0.1 1.3-0.2 2.6-0.6 4.5 1.6 0.2 2.9 0.3 4.7 0.4z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m309.5 96c-0.4-1.5-0.4-3.1-0.4-4.8 3.2 0.7 5.6 1.3 8.5 1.8q-3.5 1.5-8.1 3z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m333.7 99.7q-2.8 0.7-6.4 0.6 2.8-0.7 6.4-0.6z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m301.7 62c-0.8 2.7-1.7 5.8-5.6 2.3 1.7-1 3.5-1.6 5.6-2.3z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m289.6 65c-0.7 3.7-2.3 4.1-4.6 0.4 1.3-0.4 2.7-0.4 4.6-0.4z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m319.3 69.8c-0.6-0.9-1-2-1.3-3.4 0.5 0.8 1 1.9 1.3 3.4z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m282.9 64.6c-1 0.3-2.1 0.3-3.6 0.2 0.9-0.2 2.3-0.4 3.6-0.2z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m316.9 62.7c-1.2-0.5-2.4-1.3-3.7-2.4 1.1 0.5 2.4 1.2 3.7 2.4z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m313 59.6q-1-0.6-2.1-2.2 1 0.6 2.1 2.2z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m343.9 101.6c-0.8-0.1-1.7-0.6-2.8-1.3 0.8 0.1 1.8 0.6 2.8 1.3z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m291.6 61c0.2 0.5 0 1.1-0.3 1.8-0.1-0.4 0-1.1 0.3-1.8z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m294 60.6c-0.4 0.3-0.9 0.3-1.7 0.3 0.3-0.2 1-0.4 1.7-0.3z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m321.8 99.7q-1 0.2-2.7-0.4 1-0.2 2.7 0.4z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m299 97.1c-0.7-1.5-1.3-3.1-1.9-5 0.8-0.3 1.5-0.2 2.8 0 1.1 0.7 1.6 1.3 2.1 1.9-0.2 0.9-0.3 1.7-1.1 2.8-1 0.2-1.5 0.2-1.9 0.3z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m302.3 94c-0.8-0.6-1.3-1.2-2-1.9-0.1-0.7 0-1.2 0.8-1.9 1.3-0.2 2.1-0.2 2.8-0.2 0 1.1 0.1 2.1 0.1 3.6-0.4 0.4-0.9 0.4-1.7 0.4z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m297 87.6q-1.4-1.1-2.9-3.4 1.5 1.2 2.9 3.4z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m303.9 89.7c-0.7 0.3-1.5 0.3-2.6 0.3 0.6-0.2 1.6-0.4 2.6-0.3z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m83.3 159.2c1.6 0.1 3.3 0.4 5.4 0.8-1.5-0.1-3.4-0.3-5.4-0.8z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s67",
    d: "m66.8 171.8c-0.2 0.1-0.4-0.1-0.7-0.5 0.3-0.2 0.5 0 0.7 0.5z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m85 145.4c2-2.5 3.4-6.6 7.5-1.9 0.4 3.2 0.4 5.8 0.3 8.6-0.5 0.3-0.6 0.6-0.6 1.2-0.1 0.8-0.2 1.2-0.3 1.7-1.4 0.7-2.8 1.3-4.6 2.1-1-2.7-1.7-5.5-2.3-8.9 0-0.9-0.1-1-0.1-1.2 0.1-0.4 0.1-0.9 0.1-1.6z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m92.3 154.9c-0.3-0.4-0.2-0.8 0.1-1.7 0.4-0.7 0.5-1 0.6-1.3-0.1-2.6-0.1-5.2-0.2-8.3-0.1-1.8-0.3-3.1-0.1-4.5 1.8 2.6 3.3 5.2 5.2 8.2 0.3 0.8 0.3 1.2 0.3 1.6 0 0.9 0.3 2.1-0.1 2.4-1.7 1.4-3.6 2.4-5.8 3.6z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m98.5 148.9c-0.3-0.4-0.3-0.8-0.3-1.5 1.8-2.3 3.4-4.3 5.4-6.3 0.2 2.1 0 4.3-0.3 6.8-1.6 0.5-3 0.8-4.8 1z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m280 179.4c-1.6 1.4-2.9 2.7-4.4 3.6-0.5 0.3-1.6-0.4-2.6-0.9-1.3-7.8 3.3-10 9.6-10.1 2.8-0.1 5.6-0.1 8.8 0 0.6 0.6 0.6 1.1 0.6 1.9-4 2-7.9 3.6-12 5.5z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m274.7 163.1c1.2-1.7 2.7-3.5 4.4-5.6 6.2-5.2 6.2-5.2 11.8 0.2-6-0.3-10.9 2.6-16.2 5.4z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m299 97.3c0.4-0.3 0.9-0.3 1.7-0.3 0 0.5-0.3 1-0.6 1.5-0.4-0.3-0.7-0.6-1.1-1.2z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m71.2 155.3c1.1-2.7 2.4-5 3.8-7.7 0.6 1.8 2 4 1.5 5.8-0.2 1.1-3.3 1.5-5.3 1.9z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m84.8 147.1c0.1 0.1 0.2 0.2 0.1 0.7-0.1 0-0.3-0.1-0.4-0.3 0-0.1 0.1-0.2 0.3-0.4z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m92.8 152.1q0.2 0.2-0.4 0.8-0.3-0.3 0.4-0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenobi);
export default __webpack_public_path__ + "static/media/kenobi.abfa93739c97f715edddef107efe484b.svg";
export { ForwardRef as ReactComponent };